// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Exo+2:wght@100;200;300;400&family=Oswald:wght@200;300;400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* основной файл стилей */
@keyframes rotate_180 {
  from {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(0);
  }
}
@keyframes rotate_left {
  from {
    transform: rotate(-90deg);
  }
  to {
    transform: rotate(0);
  }
}
@keyframes rotate_down {
  from {
    transform: rotate(90deg);
  }
  to {
    transform: rotate(0);
  }
}
@keyframes opacity_1 {
  from {
    opacity: 0;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes opacity_0 {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0);
  }
}
@keyframes scale_view {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes hover_btn {
  from {
    transform: scale(1);
    opacity: 0.7;
  }
  to {
    transform: scale(1.1);
    opacity: 1;
  }
}
@keyframes hover_btn_end {
  from {
    transform: scale(1.1);
    opacity: 1;
  }
  to {
    transform: scale(1);
    opacity: 0.7;
  }
}
@keyframes save {
  from {
    margin-left: -15vw;
  }
  25% {
    margin-left: 0;
  }
  50% {
    margin-left: 0;
  }
  75% {
    margin-left: 0;
  }
  to {
    margin-left: -15vw;
  }
}
@keyframes company_is_added {
  from {
    margin-left: -384px;
  }
  30% {
    margin-left: 0;
  }
  50% {
    margin-left: 0;
  }
  70% {
    margin-left: 0;
  }
  to {
    margin-left: -384px;
  }
}
@keyframes invitation_sent {
  from {
    margin-left: -384px;
  }
  30% {
    margin-left: 0;
  }
  50% {
    margin-left: 0;
  }
  70% {
    margin-left: 0;
  }
  to {
    margin-left: -384px;
  }
}
@keyframes drop_menu {
  from {
    margin-top: -150px;
    opacity: 0;
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
@keyframes information {
  from {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
}
@keyframes feedback_up {
  from {
    bottom: 70px;
  }
  25% {
    bottom: 110px;
  }
  50% {
    bottom: 160px;
  }
  50% {
    bottom: 200px;
  }
}
body,
html {
  background-color: #F4F6F9;
  width: 100% !important;
  font-family: "Exo 2", sans-serif;
  font-weight: 300;
}

body {
  overflow-x: auto;
}

.app {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: unset;
}
@media (max-width: 1440px) {
  .app {
    height: calc(100% - 60px);
    margin: 0 auto;
  }
}

.content {
  width: 100% !important;
  flex: 1 0 auto;
}

.font_family_for_calendar {
  font-family: "Exo 2", sans-serif !important;
  font-weight: 100 !important;
}

.react-date-picker__inputGroup span {
  margin-bottom: 2px;
}

.react-date-picker__inputGroup__divider {
  color: #000 !important;
}

.react-date-picker__inputGroup__input {
  color: #000 !important;
}

.navigation {
  width: 100%;
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap !important;
  margin-left: 0px;
  margin-right: 0px;
  width: 100%;
}
@media (max-width: 1440px) {
  .navigation {
    width: 1428px !important;
    position: unset;
  }
}

.said-bar {
  width: 300px;
  min-height: 100vh;
  background-color: #343a40;
  color: #d6d7d8;
  transition: 0.5s;
}

.right-menu-block {
  width: 100%;
  min-height: 100vh;
}
.right-menu-block .right_navbar {
  position: relative;
  overflow-y: hidden !important;
}
@media (max-width: 1440px) {
  .right-menu-block .right_navbar {
    position: unset !important;
  }
}
.right-menu-block .right_navbar .navigation__navbar_long {
  height: 60px;
  background-color: #fff;
  border-bottom: #ccc 1px solid;
  position: fixed;
  top: 0;
  right: 0px;
  left: 55px;
  margin-bottom: 10px;
  z-index: 18;
  transition: 0.5s;
  display: flex;
  gap: 25px;
  justify-content: space-between;
}
@media (max-width: 1440px) {
  .right-menu-block .right_navbar .navigation__navbar_long {
    position: relative;
    left: 0px;
    width: 100% !important;
  }
}
.right-menu-block .right_navbar .navigation__navbar_long .left_side_buttons {
  padding-top: 0 !important;
  margin-top: 0 !important;
  display: flex;
  gap: 25px;
  align-items: center;
}
.right-menu-block .right_navbar .navigation__navbar_long .left_side_buttons .three_btns_group {
  padding-top: 10px;
  display: flex;
  gap: 25px;
}
@media (max-width: 1440px) {
  .right-menu-block .right_navbar .navigation__navbar_long .left_side_buttons .three_btns_group {
    margin-top: -5px;
  }
}
.right-menu-block .right_navbar .navigation__navbar_long .left_side_buttons .icon_top_navbar {
  position: absolute;
  top: 5px;
  right: 5px;
}
@media (max-width: 1440px) {
  .right-menu-block .right_navbar .navigation__navbar_long .left_side_buttons .icon_top_navbar {
    margin-top: -10px;
  }
}
.right-menu-block .right_navbar .navigation__navbar {
  height: 60px;
  background-color: #fff;
  border-bottom: #ccc 1px solid;
  position: fixed;
  top: 0;
  right: 0px;
  left: 260px;
  margin-bottom: 10px;
  z-index: 18;
  transition: 0.5s;
  display: flex;
  gap: 25px !important;
  justify-content: space-between;
}
@media (max-width: 1440px) {
  .right-menu-block .right_navbar .navigation__navbar {
    position: unset !important;
    left: 0px;
    width: 100% !important;
  }
}
@media (max-width: 1440px) {
  .right-menu-block .right_navbar .navigation__navbar .collapse_btn {
    overflow: hidden !important;
  }
}
.right-menu-block .right_navbar .navigation__navbar .left_side_buttons {
  padding-top: 0 !important;
  margin-top: 0 !important;
  display: flex;
  gap: 25px;
}
.right-menu-block .right_navbar .navigation__navbar .left_side_buttons .three_btns_group {
  padding-top: 4px;
  display: flex;
  gap: 25px;
}
@media (max-width: 1440px) {
  .right-menu-block .right_navbar .navigation__navbar .left_side_buttons .three_btns_group {
    margin-top: -5px;
    position: unset !important;
  }
}
@media (max-width: 1440px) {
  .right-menu-block .right_navbar .navigation__navbar .left_side_buttons .icon_top_navbar .dropleft .dropdown-menu {
    position: fixed;
    top: 5px;
    right: 165px;
  }
}
@media (max-width: 1440px) {
  .right-menu-block .right_navbar .navigation__navbar .left_side_buttons .icon_top_navbar {
    margin-top: -10px;
    position: unset;
  }
}
@media (max-width: 1440px) {
  .right-menu-block {
    overflow-y: hidden !important;
    position: unset !important;
  }
}

.jumbotron {
  border-radius: 0;
}

.menu-position-parent {
  width: 100%;
  margin: 20px 10px 10px 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  cursor: pointer;
}

.img_svg {
  width: 25px;
  height: 34px;
  margin: 0 5px 0 5px;
  padding: 10px 0 3px 0;
}

.img_svg_arrow {
  width: 25px;
  height: 34px;
  margin: 0 5px 0 5px;
  padding: 3px 0 3px 0;
}

.svg-left-arrow {
  animation: rotate_180 1s;
  transition: 1s;
}

.svg-right-arrow {
  animation: rotate_180 1s;
  transition: 1s;
}

.svg-left {
  width: 20px;
  height: 20px;
  padding: 0px 0 0 0;
  animation: rotate_left 0.5s;
  transition: 1s;
}

.svg-down {
  width: 20px;
  height: 20px;
  padding: 0px 0 0 0;
  animation: rotate_down 0.5s;
  transition: 1s;
}

.icon_circle {
  width: 20px;
  height: 20px;
  padding: 3px 0 0 0;
}

.icon_point {
  width: 10px;
  height: 10px;
  padding: 0 0 3px 0;
}

.card-my {
  font-weight: 400;
  width: 220px;
  height: 40px;
  padding: 7px 0 5px 0;
  border: none;
  outline: none;
  color: #d6d7d8;
  background-color: #343a40;
  transition: 0.5s;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
}

.card-my:hover {
  background-color: #6c757d;
  transition: 0.5s;
}

.card {
  background-color: inherit;
  border: none;
}

.unique-header {
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
}

.custom_file_upload {
  background-color: #007bff;
  color: #fff;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.chaild-block {
  width: 200px;
}
.chaild-block:hover {
  background-color: #6c757d;
  color: #fff;
}

.chaild-link {
  display: block;
  margin: 5px 0 5px 0;
  padding: 5px 0 5px 18px !important;
  width: 100%;
  text-decoration: none !important;
  transition: 0.5s;
  color: #d6d7d8;
}
.chaild-link:hover {
  background-color: #6c757d;
  color: #fff;
}

.chaild_link_active {
  background-color: #6c757d;
  color: #fff;
}

.chaild-link:hover .icon_point {
  transition: 0.5s;
  width: 15px;
  height: 15px;
  padding: 0 5px 3.5px 0;
  margin: 0 2.6px 0 2.6px;
}

.lotus_logo_footer {
  padding: 3px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  border: #ccc 1px solid;
  box-shadow: 2px 2px 8px rgba(150, 150, 150, 0.5);
  transition: 0.3s;
}
.lotus_logo_footer:hover {
  box-shadow: 2px 2px 8px rgb(150, 150, 150);
}

.skolkovo_logo_footer {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  box-shadow: 2px 2px 8px rgba(150, 150, 150, 0.5);
  transition: 0.3s;
}
.skolkovo_logo_footer:hover {
  box-shadow: 2px 2px 8px rgb(150, 150, 150);
}

.link_style_footer {
  text-decoration: none !important;
  color: #7b7f83;
  transition: 0.3s;
}
.link_style_footer:hover {
  color: #343a40;
}

.side_bar_logo {
  width: 100%;
  height: 70px;
  text-align: center;
  padding: 20% 10px;
  cursor: pointer;
  transition: 0.5s;
}
.side_bar_logo:hover {
  color: #fd7e14;
  transition: 0.5s;
}

.side_bar_logo_img {
  height: 65px;
  width: 65px;
  border-radius: 50%;
}

.side_bar_logo_img_vert {
  height: 35px;
  width: 35px;
  border-radius: 50%;
}

.company_logo {
  cursor: pointer;
  width: 100%;
  height: 50px;
  border-bottom: 1px #6c757d solid;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding-left: 20px;
  margin-bottom: 60px;
}
.company_logo:hover {
  color: #fd7e14;
  transition: 0.5s;
}

.company_logo_display_none {
  display: none;
}

.company_logo_vert {
  cursor: pointer;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.company_logo_img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-left: 10px;
}

.display_none {
  display: none;
}

.quest_refresh_btn {
  position: fixed;
  left: 350px;
  top: 5px;
  z-index: 19;
  cursor: pointer;
  background-color: #007bff;
}

.quest_moderation_btn {
  position: fixed;
  top: 5px;
  z-index: 19;
  cursor: pointer;
  border-radius: 5px;
}

.side_bar_logo-vert {
  width: 280px;
  height: 70px;
  margin: 50px 0px 120px -105px;
  text-align: left;
  font-size: 12px;
  padding: 15px 10px 15px 0px;
  cursor: pointer;
  transform: rotate(-90deg);
  transition: 0.5s;
}
.side_bar_logo-vert:hover {
  color: #fd7e14;
  transition: 0.5s;
}

.side_bar_logo_company_name_vert {
  position: absolute;
  left: 15px;
}

.modal_window {
  position: relative;
  transition: all;
}
@media (max-width: 1440px) {
  .modal_window {
    position: unset;
  }
}

.shadow {
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.7;
  position: relative;
  top: 0px;
  left: 0px;
  z-index: 19;
  position: fixed;
}

.shadow_form {
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
  position: relative;
  top: 0px;
  left: 0px;
  z-index: 19;
  position: fixed;
}

.shadow_quest {
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.5;
  position: relative;
  top: 0px;
  left: 0px;
  z-index: 20;
  position: fixed;
}

.shadow_form_off {
  display: none;
}

.modal_form {
  background-color: #fff;
  padding: 40px;
  position: absolute;
  position: fixed;
  top: 20vh;
  left: 30%;
  width: 40%;
  z-index: 20;
  animation: opacity_1 0.75s;
}

.modal_form_off {
  background-color: #fff;
  padding: 40px;
  position: absolute;
  position: fixed;
  top: 20vh;
  left: 30%;
  width: 40%;
  z-index: 20;
  animation: opacity_0 0.75s;
}

.modal_form_quit {
  background-color: #fff;
  padding: 40px;
  position: absolute;
  position: fixed;
  top: 20vh;
  left: 30%;
  width: 40%;
  z-index: 20;
}

.modal_form_off_quit {
  background-color: #fff;
  padding: 40px;
  position: absolute;
  position: fixed;
  top: 20vh;
  left: 30%;
  width: 40%;
  z-index: 20;
}

.form_main {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 70vw !important;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  z-index: 20;
  animation: scale_view 0.5s;
}
@media (max-width: 1440px) {
  .form_main {
    width: 1100px !important;
    position: absolute;
    left: 10vw;
  }
}
.form_main .form_container {
  position: relative;
  max-width: 98%;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
}
@media (max-width: 1440px) {
  .form_main .form_container {
    width: 900px !important;
    overflow-x: auto;
  }
}

.form_main_1 {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 70vw !important;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  z-index: 20;
  animation: scale_view 0.5s;
}
@media (max-width: 1440px) {
  .form_main_1 {
    position: absolute;
    width: 100% !important;
    top: 0px;
    left: 0px;
  }
}
.form_main_1 .invite_by_email_content {
  padding: 20px 40px 40px 80px;
}
@media (max-width: 1440px) {
  .form_main_1 .invite_by_email_content {
    overflow-y: auto;
    width: 100% !important;
  }
}
.form_main_1 .form_container {
  max-width: 98% !important;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
}
@media (max-width: 1440px) {
  .form_main_1 .form_container {
    overflow-y: auto;
    width: 100% !important;
  }
}

.form_main_view {
  position: relative;
  width: 70vw;
  background-color: #fff;
  border-radius: 5px;
  margin: 5px auto;
  box-sizing: border-box;
  z-index: 20;
}
.form_main_view .form_alert {
  margin-bottom: 0;
  cursor: pointer;
}

.btn_form {
  margin: 10px 10px;
  width: 320px;
  height: 160px;
  transition: 500ms;
  background-color: #adb5bd;
  color: #fff;
  font-weight: 400;
  border: 0;
  position: relative;
  font-size: 18px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
}

.btn_card_style {
  display: inline-block;
  cursor: pointer;
}

.btn_form_header {
  background-color: #9fa5aa;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 60px;
}

.btn_form_body {
  text-align: center;
}

.btn_form_title {
  font-size: 15px;
  margin-top: 20px;
}

.btn_form.active .check {
  position: absolute;
  top: 10px;
  right: 15px;
}

.btn_form .check {
  position: absolute;
  top: 10px;
  right: 15px;
}

.btn_form.active {
  background-color: #73c586 !important;
}

.btn_form_header.active {
  background-color: #28a745 !important;
}

.btn_form_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
}

.btn_trade_form {
  margin: 10px;
  width: 200px;
  transition: 0.5s;
}
.btn_trade_form:hover {
  box-shadow: 3px 3px 5px #6c757d;
  transition: 0.5s;
}

.span_title {
  margin: 20px 0 -15px 15px;
}

.calendar {
  margin: 25px 0 0 0;
  padding: 0 0 0 20px;
}

.phone_form {
  margin-top: 24px;
}

.date_trade_text {
  padding-top: 30px;
}

.class-mask-error {
  background-color: #dc3545;
}

.quest_main_alert {
  position: relative;
  width: 99%;
  height: 50px;
}

.quest_alert {
  position: absolute;
  top: 50px;
  width: 100%;
}

.anketa_true {
  background-color: #F4F6F9;
  padding: 0;
  min-height: 77.5vh;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  min-width: 1024px;
  margin: 50px auto 80px auto;
  max-width: 1400px;
}
.anketa_true > button {
  width: 250px;
  height: 150px;
  margin: 5px;
  text-align: center;
}

.anketa_new {
  padding: 0;
  min-height: 77.5vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
}

.footer {
  font-size: 14px;
  letter-spacing: 1px;
  background-color: #fff;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #9fa5aa;
  font-weight: bold;
  height: 57px;
  border-top: #ccc 1px solid;
}
@media (max-width: 1440px) {
  .footer {
    width: 100% !important;
  }
}

.card_block_no_position {
  position: unset;
}

.footer_vert {
  left: 55px;
  width: 2000px;
}

.footer_horizontal {
  left: 260px;
}

input[placeholder] {
  text-overflow: ellipsis;
  font-size: 16px;
}

input::-moz-placeholder {
  text-overflow: ellipsis;
  font-size: 16px;
}

input:-moz-placeholder {
  text-overflow: ellipsis;
  font-size: 16px;
}

input:-ms-input-placeholder {
  text-overflow: ellipsis;
  font-size: 16px;
}

.form-check-input {
  width: 20px;
  height: 20px;
  margin-top: 2px;
  margin-left: -1.5rem;
}

.fifteen_a_link {
  color: #343a40;
  text-decoration: none !important;
}
.fifteen_a_link:hover {
  color: #6c757d;
}

.render_value {
  box-sizing: border-box;
  padding: 2px 10px;
  background-color: rgba(212, 220, 231, 0.267);
}

.main_down_span {
  display: inline-block;
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-sizing: border-box;
  transition: 0.5s;
}

.main_down_span:hover {
  background-color: rgba(187, 185, 185, 0.993);
  transition: 0.5s;
}

.production-accordion {
  background-color: #fff;
}
.production-accordion__card__header {
  cursor: pointer;
  text-align: center;
  padding: 0;
  background-color: #007bff;
  color: #fff;
  font-weight: 400;
  font-size: 18px;
  margin: 1px;
  border-radius: 3px;
}

.icon_top_navbar_company_name {
  padding: 4px 24px;
  margin-top: 0;
  font-weight: bolder;
}

.icon_leave_modal {
  color: #dc3545;
  padding-bottom: 5px;
}

.icon_primary {
  color: #007bff;
  padding-bottom: 5px;
}

.icon_secondery {
  color: #adb5bd;
  padding-bottom: 2px;
}

.icon_success {
  color: #73c586;
  padding-bottom: 2px;
  padding-right: 5px;
}

.text-center {
  border: #ccc solid 1px;
}

.modal_common {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 4px;
  animation: scale_view 0.5s;
  width: 900px;
  min-width: 500px;
}
@media (max-width: 1440px) {
  .modal_common {
    width: 900px !important;
  }
}

.modal_common_table {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 1100px !important;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  animation: scale_view 0.5s;
}

.pipe_table_wrap {
  padding: 10px 20px;
  overflow-x: auto;
  max-height: 550px;
}

.loader_centered {
  display: flex;
  justify-content: center;
}

.button_group_table {
  position: absolute;
  right: 30px;
  bottom: -60px;
  display: flex;
  gap: 10px;
}

.equipment_table_style {
  width: 1400px;
  table-layout: fixed;
  position: relative;
  margin-bottom: 80px;
}

.modal_common_2 {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 0 5px #000;
  border-radius: 4px;
  animation: scale_view 0.5s;
}

.modal_common_mini {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 70%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 4px;
  animation: scale_view 0.5s;
}

.th_table_style {
  font-size: 16px;
  word-wrap: break-word;
}

.modal_common_ {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  animation: scale_view 0.5s;
}

.modal_common_0 {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 800px !important;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  animation: scale_view 0.5s;
}

.modal_common_1 {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 1100px !important;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  animation: scale_view 0.5s;
}
@media (max-width: 1440px) {
  .modal_common_1 {
    position: absolute;
    width: 1100px !important;
  }
}
.modal_common_1 .participant_lot_container {
  height: 68vh !important;
  overflow-y: auto;
  overflow-x: hidden;
  width: 1000px !important;
  margin: 0 auto;
}
.modal_common_1 .participant_lot_container .form_container {
  position: relative;
  max-width: 98%;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
}
@media (max-width: 1440px) {
  .modal_common_1 .participant_lot_container {
    width: 950px !important;
  }
}
@media (max-width: 1440px) {
  .modal_common_1 .participant_lot_container_padding {
    padding: 0 30px;
  }
}

.min_height_570 {
  min-height: 570px;
}

.modal_small_access {
  font-size: 14px;
  margin-left: 15px;
  overflow-y: auto;
  height: 30vh;
  min-height: 300px;
}

.modal_slide_out_warning {
  position: fixed;
  left: 0px;
  top: 40vh;
  padding: 15px 20px;
  border-radius: 5px;
  animation: company_is_added ease-in-out 3s;
}

.modal_main_loading {
  background-color: #e9ecef;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 100px;
  z-index: 30;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
}

.modal_main_saving {
  position: absolute;
  position: fixed;
  top: 40%;
  left: 0vw;
  width: 15vw;
  height: 80px;
  margin-left: -30vw;
  padding-top: 10px;
  font-size: 18px;
  text-align: center;
  background-color: #e9ecef;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  z-index: 21;
  animation: save ease-in-out 2s;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
}

.modal_information {
  position: absolute;
  position: fixed;
  top: 40%;
  left: 45%;
  width: 20vw;
  height: 150px;
  padding-top: 10px;
  font-size: 18px;
  text-align: center;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  z-index: 21;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
}
@media (max-width: 1440px) {
  .modal_information {
    width: 300px;
  }
}

.animation_for_modal {
  animation: information ease-in-out 3s;
}

.container_common {
  padding: 10px;
  margin-top: 40px;
  margin-bottom: 30px;
}

.container_chat {
  padding: 10px;
  margin-top: 10px;
}

.container_height_overflow {
  height: 100vh;
  overflow: hidden;
  width: 90%;
  margin: 60px auto 80px auto;
}
@media (max-width: 1440px) {
  .container_height_overflow {
    width: 97% !important;
  }
}
.container_height_overflow .employees_modal_small {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 4px;
  animation: scale_view 0.5s;
  width: 600px;
  min-width: 500px;
}
@media (max-width: 1440px) {
  .container_height_overflow .employees_modal_small {
    position: absolute;
    width: 600px;
    transform: none;
    top: 25%;
    left: 35%;
  }
}
.container_height_overflow .employees_modal_big {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 4px;
  animation: scale_view 0.5s;
  width: 900px;
  min-width: 500px;
}
@media (max-width: 1440px) {
  .container_height_overflow .employees_modal_big {
    position: absolute;
    width: 900px;
    transform: none;
    top: 10%;
    left: 10%;
  }
}
@media (max-width: 1440px) {
  .container_height_overflow .employees_table_list {
    width: 100% !important;
  }
}

.container_mt_2_mb_0 {
  margin-top: 2.5rem;
  margin-bottom: 0;
}

.container_search_body {
  padding: 20px 0;
}

.container_search {
  margin-top: 10px;
  margin-bottom: 10px;
}

.container_laboratory {
  margin-bottom: 0;
  min-height: 78vh;
  max-height: 60vh;
  overflow-y: auto;
}

.container_jumbotron {
  margin-bottom: 0;
  position: relative;
}

.quest_btn_container {
  background-color: #F4F6F9;
}

.container_questionairy_btn {
  text-align: center;
  width: 1140px !important;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
@media (max-width: 1440px) {
  .container_questionairy_btn {
    width: 100% !important;
  }
}

.container_participant_trade {
  position: absolute;
  left: 0;
  top: -10%;
}

.display_flex {
  display: flex;
}

.flex_justify_center {
  justify-content: center;
}

.container_check_inn {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}

.container_flex_start {
  justify-content: flex-start;
}

.container_flex_end {
  justify-content: flex-end;
}

.container_flex_direction_col {
  flex-direction: column;
}

.flex_align_items_end {
  align-items: flex-end;
}

.flex_align_items_center {
  align-items: center;
}

.flex_align_items_start {
  align-items: flex-start;
}

.container_flex_row_wrap {
  flex-direction: row;
  flex-wrap: wrap;
}

.container_flex_start_wrap {
  flex-wrap: wrap;
  justify-content: flex-start;
}

.container_flex_wrap_bordered {
  flex-wrap: wrap;
  border: 1px solid #eee;
  padding-left: 5px;
}

.container_flex_wrap {
  flex-wrap: wrap;
}

.header_alert_common {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 55px;
  border-radius: 5px 5px 0 0;
  font-weight: bold;
}

.trade_card_header {
  border-bottom: 0;
  background-color: #f0f1f2;
  height: 50px;
}

.trade_card_header_error {
  border-bottom: 0;
  background-color: #e87c86;
  height: 50px;
  color: #fff;
}

.trade_card_header_warning {
  border-bottom: 0;
  background-color: #ffc107;
  height: 50px;
  color: #fff;
}

.btn_delete {
  background-color: transparent;
  border: none;
}

.btn_outlined {
  background-color: transparent;
  border: 1px #6c757d solid;
  color: #6c757d;
}

.btn_info_filled {
  background-color: #17a2b8;
  border: 0;
}

.btn_info_filled_ml_20 {
  margin-left: 20px;
  background-color: #17a2b8;
  border: 0;
}

.btn_chat {
  background-color: transparent;
  border: 0;
  padding-left: 0;
}

.btn_chat:disabled {
  background-color: transparent;
}

.btn_chat:hover,
.btn_chat:focus,
.btn_chat:active {
  background-color: transparent !important;
  border: 0 !important;
  outline: none !important;
  outline-offset: none !important;
  box-shadow: none !important;
}

.btn_modal_group {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 8px;
}

.startChatBtn,
.startChatBtn:hover {
  position: fixed;
  bottom: 90px;
  right: 10px;
}

.startChatBtn,
.chatStopBtn {
  opacity: 70%;
}

.startChatBtn:hover,
.chatStopBtn:hover {
  opacity: 100%;
}

.modal_footer {
  display: flex;
  justify-content: space-between;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}

.phone_mask {
  margin-bottom: 8px;
  margin-top: 8px;
}

.select_form_label {
  font-size: 12px;
  color: #999;
  margin-bottom: 0.125rem;
  margin-top: 0.375rem;
}

.phone_mask_label {
  margin-bottom: -21px;
  padding-top: 5px;
  font-size: 12px;
  color: #999;
}

.calendar_col_style {
  font-size: 12px;
  color: #999;
  margin: 0 0 -17px 10px;
}

.addedToTable {
  color: #fff;
  font-weight: bolder;
  background-color: #73c586;
}

.white_bgc {
  background-color: #fff;
  color: #343a40;
}

.file_style {
  max-width: 300px;
  margin: 20px 10px;
  border: 1px solid none;
  padding: 10px;
  min-height: 100px;
  border-radius: 3px;
  background-color: #6c757d;
  color: #fff;
}

.file_body_style {
  width: 18rem;
  background-color: #9fa5aa;
  color: #f7f7f7;
}

.file_body_style_w_50 {
  width: 50rem;
  background-color: #9fa5aa;
  color: #f7f7f7;
}

.border_bottom_underline {
  border-bottom: 1px solid #ccc;
}

.border_bottom_underline_100 {
  width: 100%;
  border-bottom: 1px solid #ccc;
}

.border_top_topline_100 {
  width: 100%;
  border-top: 1px solid #ccc;
}

.border_top_topline {
  border-top: 1px solid #ccc;
}

.form_four_row {
  width: 200px;
  height: 30px;
  cursor: pointer;
  padding: 2px 0;
  color: #fd7e14;
}

.gost_metal_input_style {
  padding-top: 25px;
  width: 25%;
}

.text-muted {
  font-size: 10px;
  padding-left: 5px;
}

.display_block {
  display: block;
}

.display_inline_block {
  display: inline-block;
}

.display_inline {
  display: inline;
}

.float {
  float: right;
}

.color_fff {
  color: #fff;
}

.color_000 {
  color: #000;
}

.color_info {
  color: #17a2b8;
}

.text_align_center {
  text-align: center;
}

.background_info {
  background-color: #17a2b8;
}

.background_danger {
  background-color: #e87c86;
}

.width_30px {
  width: 30px;
}

.width_50px {
  width: 50px;
}

.error_okved {
  background-color: #dc3545 !important;
}

.width_100px {
  width: 100px;
}

.width_200px {
  width: 200px;
}

.width_100pr {
  width: 100%;
}

.width_95pr {
  width: 95%;
}

.width_290 {
  width: 290px;
}

.max_width_220 {
  max-width: 220px;
}

.width_220 {
  width: 220px;
}

.width_500 {
  width: 500px;
}

.width_40 {
  width: 40% !important;
}

.width_50 {
  width: 50% !important;
}

.width_590 {
  width: 590px !important;
}
@media (max-width: 1440px) {
  .width_590 {
    width: 590px !important;
  }
}

.width_60 {
  width: 60%;
}

.width_90 {
  width: 90%;
}

.width_50 {
  width: 50px;
}

.width_160 {
  width: 160px;
}

.width_150 {
  width: 150px;
}

.height_60 {
  height: 60px;
}

.height_450 {
  height: 450px;
}

.height_370 {
  height: 370px;
}

.height_500 {
  height: 500px;
}

.height_600 {
  height: 600px;
}

.height_80vh {
  height: 80vh;
}

.height_160 {
  height: 160px;
}

.height_100 {
  height: 100px;
}

.height_300 {
  height: 300px;
}

.height_350 {
  height: 350px;
}

.height_600 {
  height: 600px;
}

.overflow_y_scroll {
  overflow-y: scroll;
}

.overflow_x_hidden {
  overflow-x: hidden;
}

.overlay_y_scroll_on {
  overflow-y: scroll;
}

.overflow_y_auto {
  overflow-y: auto;
}

.overflow_y_hidden {
  overflow-y: hidden;
}

.p_0 {
  padding: 0;
}

.p_1 {
  padding: 1px;
}

.p_3 {
  padding: 3px;
}

.p_40 {
  padding: 40px;
}

.pr_10 {
  padding-right: 10px;
}

.pb_2 {
  padding-bottom: 2px;
}

.pb_3 {
  padding-bottom: 3px;
}

.pb_4 {
  padding-bottom: 4px;
}

.pb_5 {
  padding-bottom: 5px;
}

.pb_20 {
  padding-bottom: 20px;
}

.pb_0 {
  padding-bottom: 0 !important;
}

.pt_10 {
  padding-top: 10px;
}

.pt_25 {
  padding-top: 25px;
}

.pl_0 {
  padding-left: 0;
}

.ml_10 {
  margin-left: 10px;
}

.ml_6em {
  margin-left: 6em;
}

.m_0 {
  margin: 0;
}

.m_0_5 {
  margin: 0 5px;
}

.mt_10 {
  margin-top: 10px;
}

.mt_20 {
  margin-top: 20px;
}

.mb_20 {
  margin-bottom: 20px;
}

.mb_10 {
  margin-bottom: 10px;
}

.mb_0 {
  margin-bottom: 0px;
}

.mt_0 {
  margin-top: 0px;
}

.m_0_10 {
  margin: 0 10px;
}

.m_10_0_15_10 {
  margin: 10px 0 15px 10px;
}

.fw_bolder {
  font-weight: bolder;
}

.fw_bold_color_dark_grey {
  font-weight: 600;
  color: #343a40;
}

.f_size_09em {
  font-size: 0.9em;
}

.f_size_095em {
  font-size: 0.95em;
}

.f_size_1em {
  font-size: 1.1em;
}

.z_index_1000 {
  z-index: 1000;
}

.z_index_1001 {
  z-index: 1001;
}

.z_index_19 {
  z-index: 19;
}

.z_index_20 {
  z-index: 20;
}

.z_index_21 {
  z-index: 21;
}

.z_index_extra_big {
  z-index: 1001111;
}

.flex_gap_20 {
  gap: 20em;
}

.flex_space_around {
  justify-content: space-around;
}

.flex_gap_8 {
  gap: 8px;
}

.flex_align_center {
  align-items: center;
}

.text_decoration_none {
  text-decoration: none;
}

.transition_05s {
  transition: 0.5s;
}

.transition_075s {
  transition: 0.75s;
}

.cursor_pointer {
  cursor: pointer;
}

.cursor_auto {
  cursor: auto;
}

.table_td_hover_style {
  cursor: auto;
  transition: 0.5s;
}
.table_td_hover_style:hover {
  color: #fff;
  transition: 0.5s;
  cursor: pointer;
  background-color: #ccc;
}
.table_td_hover_style:active {
  background-color: #9fa5aa;
  transition: 0.12s;
}

.table_no_hover_style {
  cursor: auto;
  transition: 0.5s;
}

.no_hover {
  width: 100px;
  cursor: auto;
  transition: 0.5s;
}

.cursor_no_pointer {
  cursor: default;
}

.h6_forgings_group {
  padding-top: 27px;
  margin-right: 5px;
}

.h5_questionaire {
  cursor: pointer;
  margin-top: 20px;
  margin-left: 20px;
}

.arrow_right,
.arrow_left {
  min-width: auto;
  max-width: 300px;
  margin-left: auto;
  margin-bottom: 5px;
  margin-top: 10px;
  padding: 5px 10px;
  position: relative;
  border-radius: 15px;
  color: #f8f9fa;
  overflow-wrap: break-word;
  height: auto;
}

.arrow_right {
  background: #5ad18b;
}

.arrow_left {
  background: rgb(161, 161, 161);
  margin-left: 20px;
}

.arrow_right:before,
.arrow_left:before {
  content: "";
  border: solid transparent;
  position: absolute;
  bottom: 10px;
  border-width: 5px;
  margin-bottom: 1px;
}

.arrow_right:before {
  left: 100%;
  border-left-color: #5ad18b;
}

.arrow_left:before {
  right: 100%;
  border-right-color: #9fa5aa;
}

.chat_message_date_style {
  display: flex;
  justify-content: flex-end;
  color: #343a40;
  font-size: 0.7em;
}

.input.form-control {
  border: #ccc 1px solid;
}

input.form-control:focus,
.input.form-control:active {
  border: #ccc 1px solid;
  outline: none !important;
  box-shadow: none !important;
}

.recipientStyle,
.recipientStyleActive {
  padding: 10px;
  cursor: pointer;
  background-color: #3e4850;
  color: #fff;
  font-weight: bolder;
  padding-left: 15px;
  border-radius: 5px;
  font-size: 14px;
}

.recipientStyleActive {
  background-color: #3e4850;
}

.recipientStyleActive {
  background-color: #364048;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
}

.modal_chat {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  animation: scale_view 0.5s;
  overflow: hidden;
}
@media (max-width: 1440px) {
  .modal_chat {
    position: absolute;
    top: 30px;
    left: 300px;
    right: 0;
  }
}
.modal_chat .chat_grid_layout {
  background-color: #303a42;
  /* outline: 2px solid #303a42; */
  display: grid;
  grid-template-areas: "aside sidebar chatHeader" "aside sidebar messagesContent" "aside sidebar messageEnterArea";
  grid-template-columns: 70px 225px 1fr;
  padding: 0 !important;
  height: 600px;
}
.modal_chat .chat_grid_layout .leftChatBar {
  grid-area: aside;
  display: flex;
  justify-content: baseline;
  align-items: flex-start;
  padding: 0;
  margin: 0;
  height: 600px;
  border-radius: 10px;
}
.modal_chat .chat_grid_layout .leftChatBar .leftBarIcons {
  display: flex;
  gap: 10px;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}
.modal_chat .chat_grid_layout .leftChatBar .chat_online_circle {
  width: 15px;
  height: 15px;
  position: absolute;
  bottom: -3px;
  right: 1px;
  background-color: #73c586;
  border-radius: 50%;
  border: 2px solid #343a40;
}
.modal_chat .chat_grid_layout .chatNav {
  grid-area: sidebar;
  border: 0;
  height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #364048;
  overflow-y: auto;
}
.modal_chat .chat_grid_layout .chatNav .searchBarStyle,
.modal_chat .chat_grid_layout .chatNav .searchBarStyle:focus,
.modal_chat .chat_grid_layout .chatNav .searchBarStyle:active {
  width: 80%;
  border-radius: 15px;
  font-size: 14px !important;
  margin-top: 20px;
  margin-bottom: 40px;
  background-color: #303a42;
  border: 0 !important;
  color: #fff;
}
.modal_chat .chat_grid_layout .containerChat {
  padding: 0px;
  margin: 0px;
}
.modal_chat .chat_grid_layout .containerChat .contentArea {
  grid-area: messagesContent;
  height: 490px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f8f9fb;
  padding-right: 20px;
}
.modal_chat .chat_grid_layout .containerChat .chat_toast {
  width: 350px;
  background-color: #fff;
  position: absolute;
  bottom: 50px;
  margin: 0 0 0 3px;
}
.modal_chat .chat_grid_layout .containerChat .enterMessageArea {
  grid-area: messageEnterArea;
  background-color: #fff;
  height: 50px;
}
.modal_chat .chat_grid_layout .containerChat .enterMessageArea .enterMessageInputSpan {
  width: 90%;
  padding-right: 5px;
  background-color: #fff;
}

.chatHeader {
  grid-area: chatHeader;
  /* border: 1px #ccc solid; */
  margin: 0;
  background-color: #f8f9fb;
  border-radius: 0;
  height: 60px;
}

.leftBarIcon {
  background-color: transparent !important;
  border: 0 !important;
  /* border-radius: 50%; */
  padding: 10px 22px !important;
  width: 100%;
  transition: none !important;
}

.leftBarIcon:hover,
.leftBarIcon:focus,
.leftBarIcon:active {
  background-color: #3e4850 !important;
  /* background-color: transparent !important; */
  border: 0 !important;
  outline: none !important;
  outline-offset: none !important;
  box-shadow: none !important;
  border-left: 3px #5ad18b solid !important;
  transition: none !important;
}

.width_400_height_200 {
  width: 400px;
  height: 200px;
}

.dropdown-toggle::after {
  display: none !important;
  content: none !important;
  border-top: none !important;
  content: 0 !important;
  background-color: transparent !important;
  color: transparent !important;
}

.filter_col_label {
  flex-grow: 1;
}

.filter_col_input {
  flex-grow: 2;
}

.filter_box_h5 {
  text-align: center;
  margin-bottom: 20px;
}

.filter_box_container {
  padding-top: 40px;
  overflow-x: auto;
  width: 90%;
  margin: 50px auto 80px auto;
  padding-left: 50px;
  padding-right: 50px;
}
@media (max-width: 1440px) {
  .filter_box_container {
    width: 1024px !important;
  }
}

.filter_box_container_modal {
  overflow-x: auto;
  width: 90%;
  margin: 50px auto 80px auto;
}
@media (max-width: 1440px) {
  .filter_box_container_modal {
    width: 1024px !important;
  }
}

.filter_box {
  margin-bottom: 40px;
  border: 1px #f8f9fa solid;
  padding: 20px;
  border-radius: 5px;
  background-color: #fff;
}
@media (max-width: 1440px) {
  .filter_box {
    width: 100%;
  }
}

.filter_alert {
  display: flex;
  justify-content: space-between;
}

.invitation_alert {
  height: 69px;
}

.right_navbar_capacity {
  position: relative;
}

.right_navbar_capacity_modal {
  position: absolute;
  right: 20px;
  top: 17px;
  padding: 2px;
  z-index: 200;
  width: 420px;
}

.left_navbar_capacity_modal {
  position: absolute;
  right: 450px;
  top: 17px;
  padding: 2px;
  z-index: 200;
}

.universal_table {
  position: relative;
}
@media (max-width: 1440px) {
  .universal_table {
    width: 100%;
  }
}

.status_modal {
  position: absolute;
  right: 15px;
  bottom: -185px;
  width: 190px;
  text-align: center;
}

.upper_label_position {
  color: #777;
  font-size: 12px;
  position: absolute;
  left: 25px;
  top: -18px;
}

.upper_label_position_2 {
  color: #777;
  font-size: 12px;
  position: absolute;
  left: 50px;
  top: 10px;
}

.upper_label_check_inn {
  color: #777;
  font-size: 11px;
  position: absolute;
  left: 10px;
  top: -18px;
}

.navbar-toggler-icon,
.collapsed {
  display: none;
}

.upoad_file {
  padding: 5px 10px;
  cursor: pointer;
  background-color: #E5E5E5;
  border: 1px #ccc solid;
  border-radius: 3px;
  font-weight: bolder;
}

.next_btn_file {
  position: fixed;
  right: 400px;
  bottom: 250px;
}

.list_item_stile {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
  border: 1px solid rgba(0, 0, 0, 0.125);
  cursor: pointer;
  padding: 5px 20px;
}

.company_name_in_alert {
  position: absolute;
  font-size: small;
  top: 0px;
  right: 20px;
}

.navbar_info_span {
  font-size: 12px;
  position: absolute;
  top: -9px;
  right: -3px;
  color: #fff;
  width: 15px;
  height: 15px;
  text-align: center;
  border-radius: 3px;
  height: 17px;
  background-color: #28a745;
  top: -7px;
  right: 5px;
}

.navbar_info_span_date {
  width: 65px;
}

.navbar_info_span_weight {
  width: 40px;
}

.navbar_info_span_msg {
  background-color: #dc3545;
}

.navbar_info_span_rating {
  background-color: #007bff;
}

.lot_succesfully_saved_msg {
  background-color: #fff;
  height: 174px;
  color: #73c586;
}

.chat_reply_arrow_common {
  position: absolute;
  color: #F8F9FB;
  bottom: calc(50% - 15px);
  cursor: pointer;
  border: 0;
  border-radius: 50%;
  padding: 2px 4px;
  transition: 0.9s;
}

.chat_reply_arrow_right_ {
  left: -30px;
}

.chat_reply_arrow_right {
  left: -45px;
}

.chat_reply_arrow_left {
  left: 310px;
}

.chat_reply_arrow_left_ {
  left: 304px;
}

.message_on_hover:hover .chat_reply_arrow_left, .message_on_hover:hover .chat_reply_arrow_left_, .message_on_hover:hover .chat_reply_arrow_right_, .message_on_hover:hover .chat_reply_arrow_right {
  color: #fff;
  border-radius: 50%;
  padding: 2px 4px;
  background-color: #59a9ff;
  transition: 0.9s;
}

.chat_question_flex {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.very_common_modal {
  position: absolute;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 4px;
  animation: scale_view 0.5s;
}

.very_common_modal_big {
  position: fixed;
  top: 100px;
  left: 20vw;
  width: 70%;
  height: 80%;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  animation: scale_view 0.5s;
}

.absolute_pos_for_modal_footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.navibar_drop_menu_main {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 19;
  animation: drop_menu ease-in-out 0.5s;
}

.navibar_drop_menu {
  width: "300px";
  height: auto;
  background-color: #ccc;
  border-radius: 3px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 19;
  top: 55px;
  right: 20px;
}

.update_button {
  padding: 0 5px 3px 5px;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 5px;
  color: #7b7f83;
  font-weight: 400;
  transition: 0.3s;
}
.update_button:hover {
  background-color: #adb5bd;
  color: #fff;
  transition: 0.3s;
}

.reply_msg_style {
  border-left: solid 1px #fff;
  color: #fff;
  padding-left: 10px;
  font-style: italic;
  margin-bottom: 5px;
}

.box_shadow {
  box-shadow: 2px 2px 8px rgba(150, 150, 150, 0.5);
}

.conditions_style {
  font-size: 16px;
  height: 200px;
  overflow-y: auto;
  padding: 10px;
}

.read_conditions_style {
  cursor: pointer;
  font-size: 0.8em;
  color: #7b7f83;
}

.dotted_underline {
  display: inline-block;
  border-bottom: dashed 1px #7b7f83;
}

.wrapper_lot {
  width: 100% !important;
  margin: 50px auto !important;
}
@media (max-width: 1440px) {
  .wrapper_lot {
    width: 1000px !important;
    margin: 50px 20px !important;
  }
}
.wrapper_lot .wrapper_lot_content {
  width: 100% !important;
}
@media (max-width: 1440px) {
  .wrapper_lot .wrapper_lot_content {
    width: 100% !important;
  }
}
.wrapper_lot .wrapper_lot_content .lot_type_modal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 4px;
  animation: scale_view 0.5s;
  width: 500px !important;
}
.wrapper_lot .wrapper_lot_content .wrapper_lot_content_modal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 1100px !important;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  animation: scale_view 0.5s;
}
.wrapper_lot .wrapper_lot_content .wrapper_lot_content_modal .wrapper_lot_content_modal_content {
  height: 68vh !important;
  overflow-y: auto;
  overflow-x: hidden;
  width: 1000px !important;
  margin: 0 auto;
}
@media (max-width: 1440px) {
  .wrapper_lot .wrapper_lot_content .wrapper_lot_content_modal .wrapper_lot_content_modal_content {
    width: 1000px !important;
  }
}
@media (max-width: 1440px) {
  .wrapper_lot .wrapper_lot_content .wrapper_lot_content_modal {
    position: absolute;
    width: 1100px !important;
  }
}

.wrapper_lot_participant {
  width: 97% !important;
  margin: 50px auto !important;
}
@media (max-width: 1440px) {
  .wrapper_lot_participant {
    width: 1100px !important;
    margin: 50px 20px !important;
  }
}
.wrapper_lot_participant .wrapper_lot_participant_position_modal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 1100px !important;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  animation: scale_view 0.5s;
}
@media (max-width: 1440px) {
  .wrapper_lot_participant .wrapper_lot_participant_position_modal {
    position: absolute;
  }
}
.wrapper_lot_participant .wrapper_lot_participant_position_modal .wrapper_lot_participant_position_modal_content {
  width: 90% !important;
  margin: 0 auto;
}

.lot_participant_modal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  animation: scale_view 0.5s;
}
.lot_participant_modal .lot_participant_modal_content {
  height: 68vh !important;
  overflow-y: auto;
  overflow-x: hidden;
  width: 1000px !important;
  margin: 0 auto;
}

.invite_by_email {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 1000px;
  background-color: #fff;
  z-index: 20;
  animation: scale_view 0.5s;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
}
.invite_by_email .invite_by_email_content {
  padding: 20px 50px 20px 50px;
  min-height: 550px;
  height: 600px;
}

.sh {
  position: fixed;
  left: 0%;
  top: 0%;
  transform: translate(0%, 0%);
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 20;
}

.lot_position_modal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 1200px !important;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  animation: scale_view 0.5s;
}
@media (max-width: 1440px) {
  .lot_position_modal {
    position: absolute;
    top: 0;
    left: 0;
    width: 1200px !important;
  }
}
.lot_position_modal .lot_position_modal_content {
  height: 68vh !important;
  overflow-y: auto;
  overflow-x: hidden;
  width: 1100px !important;
  margin: 0 auto;
}
.lot_position_modal .lot_chosen_position_modal {
  position: absolute;
  top: 0;
  left: 0;
  width: 1200px !important;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  animation: scale_view 0.5s;
}

.quit_modal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 4px;
  animation: scale_view 0.5s;
  width: 500px;
  min-width: 500px;
}
@media (max-width: 1440px) {
  .quit_modal {
    position: absolute;
  }
}

.create_template_modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 4px;
  animation: scale_view 0.5s;
}
@media (max-width: 1440px) {
  .create_template_modal {
    position: absolute;
    width: 680px !important;
  }
  .create_template_modal .create_template_heading {
    font-size: 0.99em;
  }
}

.dropdown-menu {
  overflow-y: hidden !important;
  z-index: 1000000000;
  position: absolute;
}
.dropdown-menu .show {
  overflow-y: hidden !important;
}
@media (max-width: 1440px) {
  .dropdown-menu .show {
    overflow-y: hidden !important;
  }
}

.modal_common_1_trade {
  position: fixed;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  width: 80vw;
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  animation: scale_view 0.5s;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1440px) {
  .modal_common_1_trade {
    position: absolute;
    width: 1330px !important;
  }
}
.modal_common_1_trade .timer_bar {
  margin-top: 55px;
  background-color: #f8f9fa;
}
.modal_common_1_trade .timer_bar_content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  height: 60px;
}
.modal_common_1_trade .modal_trade_content {
  max-height: 65%;
  height: 64vh;
  max-width: 1300px;
  overflow-y: auto;
  margin-top: 10px;
}
.modal_common_1_trade .modal_trade_content .table_container {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  position: relative;
  margin-bottom: 40px;
  margin-left: -15px;
}
.modal_common_1_trade .modal_trade_content .table_container .main_table {
  position: absolute;
  width: 450px;
  z-index: 200;
}
.modal_common_1_trade .modal_trade_content .table_container .secondary_table {
  overflow-x: hidden;
  z-index: 199;
  transition: 0.8;
}
.modal_common_1_trade .modal_trade_content .scroll_area {
  position: absolute;
  position: sticky;
  bottom: 0px;
  z-index: 201;
  left: 0;
  right: 20px;
  background-color: transparent;
  padding: 10px;
}

.blur_shadow_green {
  box-shadow: inset #73c586 0 0 5px 5px, #73c586 0 0 2px 2px;
}

.blur_shadow_grey {
  box-shadow: inset #7b7f83 0 0 5px 5px, #7b7f83 0 0 2px 2px;
}

.offline_span {
  display: inline-block;
  background-color: #7b7f83;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: 8px;
}

.online_span {
  display: inline-block;
  background-color: #73c586;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: 8px;
}

.offline_span_eye {
  width: 8px;
  height: 8px;
  font-size: 10px;
  margin-left: 8px;
}

.online_span_eye {
  color: #28a745;
  width: 8px;
  height: 8px;
  margin-left: 8px;
}

.all_modals_footer_space_between .modal-footer {
  display: flex;
  justify-content: space-between !important;
}

.style_for_icons {
  margin-right: 5px;
  padding-bottom: 2px;
}

.new_window_icon {
  position: absolute;
  top: 2px;
  right: 2px;
  padding-bottom: 6px;
}

.dropdown_codes {
  background-color: white;
  display: flex;
  flex-direction: column;
  border: 1px solid gray;
  position: absolute;
  right: 4em;
  top: 88px;
  width: 300px;
  z-index: 32;
  height: -moz-fit-content;
  height: fit-content;
  overflow-y: auto;
  max-height: 200px;
}

.dropdown_codes:empty {
  border: none;
}

.dropdown_codes-row {
  cursor: pointer;
  text-align: start;
  margin: 2px 0;
  padding: 2px;
}
.dropdown_codes-row:hover {
  background-color: #d5d8da;
}

.feedback {
  position: fixed;
  right: 20px;
  bottom: 50px;
  transition: 0.9s;
}
.feedback .feedback_btn {
  border-radius: 15px;
  width: 350px;
  height: 60px;
  background: #17a2b8;
  border: 1px solid #17a2b8;
}
.feedback .feedback_btn .feedback_icon {
  position: absolute;
  right: 10px;
  box-shadow: 2px 2px 8px rgba(150, 150, 150, 0.5);
}
.feedback .feedback_form {
  width: 320px;
  display: flex;
  flex-direction: column;
  gap: 35px;
  height: 450px;
  padding: 30px 10px;
  margin-left: 16px;
  background-color: #fafbfb;
  transition: 0.9s;
  border-radius: 0 0 10px 10px;
  box-shadow: -2px -2px 8px rgba(150, 150, 150, 0.5);
}
.feedback .feedback_form :nth-child(4) {
  margin-bottom: 10px;
}
.feedback .feedback_form .feedback_input {
  border-radius: 15px;
  background-color: #F4F6F9;
}
.feedback .feedback_form .input_error {
  border: 1px #e87c86 solid;
  background-color: #e87c86;
}
.feedback .feedback_form .feedback_submit_btn {
  border-radius: 15px;
}

.feedback_down {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 35px;
  transition: 0.5s;
  color: #17a2b8;
}

.feedback_is_open {
  border-radius: 50%;
  background: #68C2D0;
  box-shadow: 2px 2px 8px rgba(80, 78, 78, 0.5);
  color: #fff;
  transition: 0.5s;
}

.feedback_down:hover {
  border-radius: 50%;
  background: #68C2D0;
  box-shadow: 2px 2px 8px rgba(80, 78, 78, 0.5);
  color: #fff;
}

.feedback_down_lower {
  bottom: 30px;
}

.feedback_down_higher {
  bottom: 70px;
}

.highlighted {
  border: 1px #28a745 solid;
  background-color: #f1f9f3;
}

.unique_number_input {
  border: #007bff 2px solid;
}

.base_modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0 0 10px #000;
  border-radius: 5px;
  z-index: 1000;
}

.modal_large {
  width: 1100px;
  height: 80vh;
}

.modal_medium {
  width: 800px;
  height: 60vh;
}

.modal_small {
  width: 500px;
  height: 40vh;
}

.modal_content {
  overflow-y: auto;
  overflow-x: hidden;
  margin: 20px;
}

.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.modal_overlay_second {
  z-index: 1000;
}

.button_container {
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/style/main.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,yBAAyB;AAYzB;EACE;IAEU,yBAAyB;EACnC;EACA;IAEU,oBAAoB;EAC9B;AACF;AAWA;EACE;IAEU,yBAAyB;EACnC;EACA;IAEU,oBAAoB;EAC9B;AACF;AAWA;EACE;IAEU,wBAAwB;EAClC;EACA;IAEU,oBAAoB;EAC9B;AACF;AAaA;EACE;IACE,UAAU;IAEF,mBAAmB;EAC7B;EACA;IACE,UAAU;IAEF,mBAAmB;EAC7B;AACF;AAaA;EACE;IACE,UAAU;IAEF,mBAAmB;EAC7B;EACA;IACE,UAAU;IAEF,mBAAmB;EAC7B;AACF;AASA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AAaA;EACE;IAEU,mBAAmB;IAC3B,YAAY;EACd;EACA;IAEU,qBAAqB;IAC7B,UAAU;EACZ;AACF;AAaA;EACE;IAEU,qBAAqB;IAC7B,UAAU;EACZ;EACA;IAEU,mBAAmB;IAC3B,YAAY;EACd;AACF;AAkBA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;AACF;AAkBA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;AACF;AAkBA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;AACF;AAWA;EACE;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,aAAa;IACb,UAAU;EACZ;AACF;AAeA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AAeA;EACE;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAIL,sBAAsB;EAC9B,YAAY;EACZ,eAAe;AACjB;AACA;EACE;IACE,yBAAyB;IACzB,cAAc;EAChB;AACF;;AAEA;EACE,sBAAsB;EAGd,cAAc;AACxB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EAGZ,aAAa;EAIL,mBAAmB;EAEvB,4BAA4B;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EAEd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;EACf,MAAM;EACN,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,WAAW;EAEX,gBAAgB;EAGhB,aAAa;EACb,SAAS;EAGD,8BAA8B;AACxC;AACA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,sBAAsB;EACxB;AACF;AACA;EACE,yBAAyB;EACzB,wBAAwB;EAGxB,aAAa;EACb,SAAS;EAGD,mBAAmB;AAC7B;AACA;EACE,iBAAiB;EAGjB,aAAa;EACb,SAAS;AACX;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;EACf,MAAM;EACN,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,WAAW;EAEX,gBAAgB;EAGhB,aAAa;EACb,oBAAoB;EAGZ,8BAA8B;AACxC;AACA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,sBAAsB;EACxB;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,yBAAyB;EACzB,wBAAwB;EAGxB,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;EAGhB,aAAa;EACb,SAAS;AACX;AACA;EACE;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,eAAe;IACf,QAAQ;IACR,YAAY;EACd;AACF;AACA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAG3B,aAAa;EAIL,mBAAmB;EAEvB,iBAAiB;EAGb,2BAA2B;EACnC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EAEU,wBAAwB;EAEhC,cAAc;AAChB;;AAEA;EAEU,wBAAwB;EAEhC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAEV,2BAA2B;EAEnC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAEV,2BAA2B;EAEnC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,yBAAyB;EAEzB,gBAAgB;EAGhB,aAAa;EAET,iBAAiB;EAIb,mBAAmB;EAGnB,2BAA2B;AACrC;;AAEA;EACE,yBAAyB;EAEzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,gCAAgC;EAEhC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EAEd,gDAAgD;EAExD,gBAAgB;AAClB;AACA;EAEU,0CAA0C;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAEV,gDAAgD;EAExD,gBAAgB;AAClB;AACA;EAEU,0CAA0C;AACpD;;AAEA;EACE,gCAAgC;EAChC,cAAc;EAEd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EAEf,gBAAgB;AAClB;AACA;EACE,cAAc;EAEd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gCAAgC;EAGhC,aAAa;EAGL,2BAA2B;EAG3B,mBAAmB;EAC3B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EAEd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EAGZ,aAAa;EAGL,uBAAuB;EAGvB,mBAAmB;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EAEP,yBAAyB;EAEjC,gBAAgB;AAClB;AACA;EACE,cAAc;EAEd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAElB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EAEH,0BAA0B;AACpC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EAEH,0BAA0B;AACpC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,sBAAsB;EACtB,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAClB,WAAW;EAEH,0BAA0B;AACpC;AACA;EACE;IACE,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,sBAAsB;EACtB,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAClB,WAAW;EAEH,0BAA0B;AACpC;AACA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,SAAS;EACX;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE;IACE,gBAAgB;IAChB,sBAAsB;EACxB;AACF;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAER,sBAAsB;EAC9B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EAEb,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,eAAe;EAEP,0CAA0C;AACpD;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EAGzB,aAAa;EAGL,mBAAmB;EAGnB,uBAAuB;EAC/B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EAGE,aAAa;EAGL,8BAA8B;EAG9B,mBAAmB;EAC3B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EAEZ,gBAAgB;AAClB;AACA;EAEU,+BAA+B;EAEvC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAGlB,aAAa;EAIL,mBAAmB;EAEvB,eAAe;EAGX,uBAAuB;EAE3B,yBAAyB;EAC7B,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAGlB,aAAa;EAIL,sBAAsB;EAGtB,2BAA2B;EAE/B,yBAAyB;AAC/B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EAGnB,aAAa;EAGL,8BAA8B;EAG9B,mBAAmB;EAC3B,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;;AAEA;EAEU,sBAAsB;EAC9B,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAEV,sBAAsB;EAE9B,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAE5C,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;EAClC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,wBAAwB;EACxB,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EAGE,aAAa;EAGL,uBAAuB;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EAGb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,sBAAsB;EAEd,wBAAwB;EAChC,kBAAkB;EAEV,0BAA0B;AACpC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,UAAU;EAEF,gCAAgC;EACxC,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,uBAAuB;EACvB,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,wBAAwB;EACxB,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;AACA;EACE;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;AACF;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAEV,0CAA0C;AACpD;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,YAAY;EACZ,aAAa;EACb,WAAW;EACX,mBAAmB;EAGnB,aAAa;EAIL,sBAAsB;EAGtB,mBAAmB;EAGnB,6BAA6B;EAE7B,0CAA0C;AACpD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EAEjB,yBAAyB;EACjC,kBAAkB;EAClB,WAAW;EAEH,8BAA8B;EAE9B,0CAA0C;AACpD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAClB,WAAW;EAEH,0CAA0C;AACpD;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EAEU,qCAAqC;AAC/C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;EAClC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,YAAY;IAEJ,eAAe;IACvB,QAAQ;IACR,SAAS;EACX;AACF;AACA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;EAClC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,YAAY;IAEJ,eAAe;IACvB,QAAQ;IACR,SAAS;EACX;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;EAGd,aAAa;EAET,eAAe;EAGX,uBAAuB;AACjC;AACA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;;AAEA;EAGE,aAAa;AACf;;AAEA;EAGU,uBAAuB;AACjC;;AAEA;EAGU,8BAA8B;EAG9B,mBAAmB;EAC3B,gBAAgB;AAClB;;AAEA;EAGU,2BAA2B;AACrC;;AAEA;EAGU,yBAAyB;AACnC;;AAEA;EAIU,sBAAsB;AAChC;;AAEA;EAGU,qBAAqB;AAC/B;;AAEA;EAGU,mBAAmB;AAC7B;;AAEA;EAGU,uBAAuB;AACjC;;AAEA;EAIU,mBAAmB;EAEvB,eAAe;AACrB;;AAEA;EAEM,eAAe;EAGX,2BAA2B;AACrC;;AAEA;EAEM,eAAe;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EAEM,eAAe;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,wCAAwC;EACxC,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;EAEvB,2BAA2B;AACrC;;AAEA;EAGE,aAAa;EAGL,yBAAyB;EACjC,WAAW;EACX,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EAGE,aAAa;EAGL,8BAA8B;EACtC,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EAEM,6BAA6B;AACnC;;AAEA;EACE,QAAQ;AACV;;AAEA;EAGU,mBAAmB;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EAEZ,gBAAgB;AAClB;AACA;EACE,WAAW;EAEX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,yBAAyB;EAEzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EAEZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EAEZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EAGE,aAAa;EAGL,yBAAyB;EACjC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,wBAAwB;EAEhB,2BAA2B;AACrC;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;EAClC,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,QAAQ;EACV;AACF;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,gHAAgH;EAChH,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,gBAAgB;EAGhB,aAAa;EAGL,yBAAyB;EAGzB,uBAAuB;EAC/B,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;AACA;EAGE,aAAa;EACb,SAAS;EAID,sBAAsB;EAC9B,aAAa;EACb,WAAW;EAGH,mBAAmB;EAGnB,8BAA8B;EACtC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;;EAGE,UAAU;EACV,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,wBAAwB;EACxB,6BAA6B;EAC7B,WAAW;EAEX,2BAA2B;AAC7B;;AAEA;;;EAGE,oCAAoC;EACpC,8CAA8C;EAC9C,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;EAEvB,2BAA2B;EACnC,yCAAyC;EAEzC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EAGU,YAAY;AACtB;;AAEA;EAGU,YAAY;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EAGE,aAAa;EAGL,8BAA8B;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EAGE,aAAa;EAGL,uBAAuB;EAGvB,mBAAmB;EAC3B,UAAU;EACV,sCAAsC;EACtC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAEhB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EAEzB,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAGL,uBAAuB;EAGvB,mBAAmB;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;;AAEA;EACE,eAAe;EACf,UAAU;EACV,UAAU;EACV,UAAU;EACV,WAAW;EACX,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EAEH,qCAAqC;AAC/C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EAGb,aAAa;EAIL,sBAAsB;EAC9B,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAEhB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EAEX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EAEU,gDAAgD;AAC1D;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;AACF;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;EAClC,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,wBAAwB;EACxB,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;AACF;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;AACF;AACA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,wBAAwB;EACxB,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,aAAa;EACb,sBAAsB;EACtB,WAAW;EAEH,0BAA0B;EAE1B,yBAAyB;EACjC,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,OAAO;EAEC,4BAA4B;EACpC,WAAW;EACX,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,wBAAwB;EACxB,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;AACA;EACE;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,wBAAwB;EAC1B;AACF;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,wBAAwB;EACxB,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EAEA,gCAAgC;EACxC,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;EAClC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EAED,gCAAgC;EACxC,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;AACpC;AACA;EACE;IACE,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,eAAe;EAEP,gCAAgC;EACxC,QAAQ;EACR,SAAS;EACT,WAAW;EACX,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAEV,0BAA0B;EAGlC,aAAa;EAIL,sBAAsB;AAChC;AACA;EACE;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;AACF;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EAGE,aAAa;EAGL,2BAA2B;EAG3B,mBAAmB;EAC3B,SAAS;EACT,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EAGE,aAAa;EAET,iBAAiB;EAGb,mBAAmB;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EAEZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,WAAW;EACX,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EAEU,0DAA0D;AACpE;;AAEA;EAEU,0DAA0D;AACpE;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAGL,yCAAyC;AACnD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EAGvB,aAAa;EAIL,sBAAsB;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,WAAW;EAEX,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EAEZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;EAEH,gDAAgD;AAC1D;AACA;EACE,YAAY;EAGZ,aAAa;EAIL,sBAAsB;EAC9B,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EAEzB,gBAAgB;EAChB,4BAA4B;EAEpB,kDAAkD;AAC5D;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAGlB,aAAa;EAGL,uBAAuB;EAGvB,mBAAmB;EAC3B,eAAe;EACf,eAAe;EAEf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EAEX,6CAA6C;EACrD,WAAW;EAEX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EAEX,6CAA6C;EACrD,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EAED,gCAAgC;EACxC,sBAAsB;EAEd,yBAAyB;EACjC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EAGE,aAAa;EAGL,yBAAyB;AACnC","sourcesContent":["@charset \"UTF-8\";\n/* основной файл стилей */\n@import url(\"https://fonts.googleapis.com/css2?family=Exo+2:wght@100;200;300;400&family=Oswald:wght@200;300;400&display=swap\");\n@-webkit-keyframes rotate_180 {\n  from {\n    -webkit-transform: rotate(180deg);\n            transform: rotate(180deg);\n  }\n  to {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n  }\n}\n@keyframes rotate_180 {\n  from {\n    -webkit-transform: rotate(180deg);\n            transform: rotate(180deg);\n  }\n  to {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n  }\n}\n@-webkit-keyframes rotate_left {\n  from {\n    -webkit-transform: rotate(-90deg);\n            transform: rotate(-90deg);\n  }\n  to {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n  }\n}\n@keyframes rotate_left {\n  from {\n    -webkit-transform: rotate(-90deg);\n            transform: rotate(-90deg);\n  }\n  to {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n  }\n}\n@-webkit-keyframes rotate_down {\n  from {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg);\n  }\n  to {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n  }\n}\n@keyframes rotate_down {\n  from {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg);\n  }\n  to {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n  }\n}\n@-webkit-keyframes opacity_1 {\n  from {\n    opacity: 0;\n    -webkit-transform: scale(0);\n            transform: scale(0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n@keyframes opacity_1 {\n  from {\n    opacity: 0;\n    -webkit-transform: scale(0);\n            transform: scale(0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n@-webkit-keyframes opacity_0 {\n  from {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: scale(0);\n            transform: scale(0);\n  }\n}\n@keyframes opacity_0 {\n  from {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: scale(0);\n            transform: scale(0);\n  }\n}\n@-webkit-keyframes scale_view {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes scale_view {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes hover_btn {\n  from {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.7;\n  }\n  to {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n    opacity: 1;\n  }\n}\n@keyframes hover_btn {\n  from {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.7;\n  }\n  to {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes hover_btn_end {\n  from {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n    opacity: 1;\n  }\n  to {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.7;\n  }\n}\n@keyframes hover_btn_end {\n  from {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n    opacity: 1;\n  }\n  to {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.7;\n  }\n}\n@-webkit-keyframes save {\n  from {\n    margin-left: -15vw;\n  }\n  25% {\n    margin-left: 0;\n  }\n  50% {\n    margin-left: 0;\n  }\n  75% {\n    margin-left: 0;\n  }\n  to {\n    margin-left: -15vw;\n  }\n}\n@keyframes save {\n  from {\n    margin-left: -15vw;\n  }\n  25% {\n    margin-left: 0;\n  }\n  50% {\n    margin-left: 0;\n  }\n  75% {\n    margin-left: 0;\n  }\n  to {\n    margin-left: -15vw;\n  }\n}\n@-webkit-keyframes company_is_added {\n  from {\n    margin-left: -384px;\n  }\n  30% {\n    margin-left: 0;\n  }\n  50% {\n    margin-left: 0;\n  }\n  70% {\n    margin-left: 0;\n  }\n  to {\n    margin-left: -384px;\n  }\n}\n@keyframes company_is_added {\n  from {\n    margin-left: -384px;\n  }\n  30% {\n    margin-left: 0;\n  }\n  50% {\n    margin-left: 0;\n  }\n  70% {\n    margin-left: 0;\n  }\n  to {\n    margin-left: -384px;\n  }\n}\n@-webkit-keyframes invitation_sent {\n  from {\n    margin-left: -384px;\n  }\n  30% {\n    margin-left: 0;\n  }\n  50% {\n    margin-left: 0;\n  }\n  70% {\n    margin-left: 0;\n  }\n  to {\n    margin-left: -384px;\n  }\n}\n@keyframes invitation_sent {\n  from {\n    margin-left: -384px;\n  }\n  30% {\n    margin-left: 0;\n  }\n  50% {\n    margin-left: 0;\n  }\n  70% {\n    margin-left: 0;\n  }\n  to {\n    margin-left: -384px;\n  }\n}\n@-webkit-keyframes drop_menu {\n  from {\n    margin-top: -150px;\n    opacity: 0;\n  }\n  to {\n    margin-top: 0;\n    opacity: 1;\n  }\n}\n@keyframes drop_menu {\n  from {\n    margin-top: -150px;\n    opacity: 0;\n  }\n  to {\n    margin-top: 0;\n    opacity: 1;\n  }\n}\n@-webkit-keyframes information {\n  from {\n    opacity: 0;\n  }\n  25% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 1;\n  }\n  75% {\n    opacity: 1;\n  }\n}\n@keyframes information {\n  from {\n    opacity: 0;\n  }\n  25% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 1;\n  }\n  75% {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes feedback_up {\n  from {\n    bottom: 70px;\n  }\n  25% {\n    bottom: 110px;\n  }\n  50% {\n    bottom: 160px;\n  }\n  50% {\n    bottom: 200px;\n  }\n}\n@keyframes feedback_up {\n  from {\n    bottom: 70px;\n  }\n  25% {\n    bottom: 110px;\n  }\n  50% {\n    bottom: 160px;\n  }\n  50% {\n    bottom: 200px;\n  }\n}\nbody,\nhtml {\n  background-color: #F4F6F9;\n  width: 100% !important;\n  font-family: \"Exo 2\", sans-serif;\n  font-weight: 300;\n}\n\nbody {\n  overflow-x: auto;\n}\n\n.app {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  height: 100%;\n  position: unset;\n}\n@media (max-width: 1440px) {\n  .app {\n    height: calc(100% - 60px);\n    margin: 0 auto;\n  }\n}\n\n.content {\n  width: 100% !important;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n}\n\n.font_family_for_calendar {\n  font-family: \"Exo 2\", sans-serif !important;\n  font-weight: 100 !important;\n}\n\n.react-date-picker__inputGroup span {\n  margin-bottom: 2px;\n}\n\n.react-date-picker__inputGroup__divider {\n  color: #000 !important;\n}\n\n.react-date-picker__inputGroup__input {\n  color: #000 !important;\n}\n\n.navigation {\n  width: 100%;\n  min-height: 100vh;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: nowrap !important;\n      flex-wrap: nowrap !important;\n  margin-left: 0px;\n  margin-right: 0px;\n  width: 100%;\n}\n@media (max-width: 1440px) {\n  .navigation {\n    width: 1428px !important;\n    position: unset;\n  }\n}\n\n.said-bar {\n  width: 300px;\n  min-height: 100vh;\n  background-color: #343a40;\n  color: #d6d7d8;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.right-menu-block {\n  width: 100%;\n  min-height: 100vh;\n}\n.right-menu-block .right_navbar {\n  position: relative;\n  overflow-y: hidden !important;\n}\n@media (max-width: 1440px) {\n  .right-menu-block .right_navbar {\n    position: unset !important;\n  }\n}\n.right-menu-block .right_navbar .navigation__navbar_long {\n  height: 60px;\n  background-color: #fff;\n  border-bottom: #ccc 1px solid;\n  position: fixed;\n  top: 0;\n  right: 0px;\n  left: 55px;\n  margin-bottom: 10px;\n  z-index: 18;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 25px;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n@media (max-width: 1440px) {\n  .right-menu-block .right_navbar .navigation__navbar_long {\n    position: relative;\n    left: 0px;\n    width: 100% !important;\n  }\n}\n.right-menu-block .right_navbar .navigation__navbar_long .left_side_buttons {\n  padding-top: 0 !important;\n  margin-top: 0 !important;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 25px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.right-menu-block .right_navbar .navigation__navbar_long .left_side_buttons .three_btns_group {\n  padding-top: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 25px;\n}\n@media (max-width: 1440px) {\n  .right-menu-block .right_navbar .navigation__navbar_long .left_side_buttons .three_btns_group {\n    margin-top: -5px;\n  }\n}\n.right-menu-block .right_navbar .navigation__navbar_long .left_side_buttons .icon_top_navbar {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n}\n@media (max-width: 1440px) {\n  .right-menu-block .right_navbar .navigation__navbar_long .left_side_buttons .icon_top_navbar {\n    margin-top: -10px;\n  }\n}\n.right-menu-block .right_navbar .navigation__navbar {\n  height: 60px;\n  background-color: #fff;\n  border-bottom: #ccc 1px solid;\n  position: fixed;\n  top: 0;\n  right: 0px;\n  left: 260px;\n  margin-bottom: 10px;\n  z-index: 18;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 25px !important;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n@media (max-width: 1440px) {\n  .right-menu-block .right_navbar .navigation__navbar {\n    position: unset !important;\n    left: 0px;\n    width: 100% !important;\n  }\n}\n@media (max-width: 1440px) {\n  .right-menu-block .right_navbar .navigation__navbar .collapse_btn {\n    overflow: hidden !important;\n  }\n}\n.right-menu-block .right_navbar .navigation__navbar .left_side_buttons {\n  padding-top: 0 !important;\n  margin-top: 0 !important;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 25px;\n}\n.right-menu-block .right_navbar .navigation__navbar .left_side_buttons .three_btns_group {\n  padding-top: 4px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 25px;\n}\n@media (max-width: 1440px) {\n  .right-menu-block .right_navbar .navigation__navbar .left_side_buttons .three_btns_group {\n    margin-top: -5px;\n    position: unset !important;\n  }\n}\n@media (max-width: 1440px) {\n  .right-menu-block .right_navbar .navigation__navbar .left_side_buttons .icon_top_navbar .dropleft .dropdown-menu {\n    position: fixed;\n    top: 5px;\n    right: 165px;\n  }\n}\n@media (max-width: 1440px) {\n  .right-menu-block .right_navbar .navigation__navbar .left_side_buttons .icon_top_navbar {\n    margin-top: -10px;\n    position: unset;\n  }\n}\n@media (max-width: 1440px) {\n  .right-menu-block {\n    overflow-y: hidden !important;\n    position: unset !important;\n  }\n}\n\n.jumbotron {\n  border-radius: 0;\n}\n\n.menu-position-parent {\n  width: 100%;\n  margin: 20px 10px 10px 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  cursor: pointer;\n}\n\n.img_svg {\n  width: 25px;\n  height: 34px;\n  margin: 0 5px 0 5px;\n  padding: 10px 0 3px 0;\n}\n\n.img_svg_arrow {\n  width: 25px;\n  height: 34px;\n  margin: 0 5px 0 5px;\n  padding: 3px 0 3px 0;\n}\n\n.svg-left-arrow {\n  -webkit-animation: rotate_180 1s;\n          animation: rotate_180 1s;\n  -webkit-transition: 1s;\n  transition: 1s;\n}\n\n.svg-right-arrow {\n  -webkit-animation: rotate_180 1s;\n          animation: rotate_180 1s;\n  -webkit-transition: 1s;\n  transition: 1s;\n}\n\n.svg-left {\n  width: 20px;\n  height: 20px;\n  padding: 0px 0 0 0;\n  -webkit-animation: rotate_left 0.5s;\n          animation: rotate_left 0.5s;\n  -webkit-transition: 1s;\n  transition: 1s;\n}\n\n.svg-down {\n  width: 20px;\n  height: 20px;\n  padding: 0px 0 0 0;\n  -webkit-animation: rotate_down 0.5s;\n          animation: rotate_down 0.5s;\n  -webkit-transition: 1s;\n  transition: 1s;\n}\n\n.icon_circle {\n  width: 20px;\n  height: 20px;\n  padding: 3px 0 0 0;\n}\n\n.icon_point {\n  width: 10px;\n  height: 10px;\n  padding: 0 0 3px 0;\n}\n\n.card-my {\n  font-weight: 400;\n  width: 220px;\n  height: 40px;\n  padding: 7px 0 5px 0;\n  border: none;\n  outline: none;\n  color: #d6d7d8;\n  background-color: #343a40;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.card-my:hover {\n  background-color: #6c757d;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.card {\n  background-color: inherit;\n  border: none;\n}\n\n.unique-header {\n  background-color: #007bff;\n  color: #fff;\n  cursor: pointer;\n}\n\n.custom_file_upload {\n  background-color: #007bff;\n  color: #fff;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.chaild-block {\n  width: 200px;\n}\n.chaild-block:hover {\n  background-color: #6c757d;\n  color: #fff;\n}\n\n.chaild-link {\n  display: block;\n  margin: 5px 0 5px 0;\n  padding: 5px 0 5px 18px !important;\n  width: 100%;\n  text-decoration: none !important;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  color: #d6d7d8;\n}\n.chaild-link:hover {\n  background-color: #6c757d;\n  color: #fff;\n}\n\n.chaild_link_active {\n  background-color: #6c757d;\n  color: #fff;\n}\n\n.chaild-link:hover .icon_point {\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  width: 15px;\n  height: 15px;\n  padding: 0 5px 3.5px 0;\n  margin: 0 2.6px 0 2.6px;\n}\n\n.lotus_logo_footer {\n  padding: 3px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  margin-right: 10px;\n  border: #ccc 1px solid;\n  -webkit-box-shadow: 2px 2px 8px rgba(150, 150, 150, 0.5);\n          box-shadow: 2px 2px 8px rgba(150, 150, 150, 0.5);\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.lotus_logo_footer:hover {\n  -webkit-box-shadow: 2px 2px 8px rgb(150, 150, 150);\n          box-shadow: 2px 2px 8px rgb(150, 150, 150);\n}\n\n.skolkovo_logo_footer {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  margin-right: 10px;\n  -webkit-box-shadow: 2px 2px 8px rgba(150, 150, 150, 0.5);\n          box-shadow: 2px 2px 8px rgba(150, 150, 150, 0.5);\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.skolkovo_logo_footer:hover {\n  -webkit-box-shadow: 2px 2px 8px rgb(150, 150, 150);\n          box-shadow: 2px 2px 8px rgb(150, 150, 150);\n}\n\n.link_style_footer {\n  text-decoration: none !important;\n  color: #7b7f83;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.link_style_footer:hover {\n  color: #343a40;\n}\n\n.side_bar_logo {\n  width: 100%;\n  height: 70px;\n  text-align: center;\n  padding: 20% 10px;\n  cursor: pointer;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n.side_bar_logo:hover {\n  color: #fd7e14;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.side_bar_logo_img {\n  height: 65px;\n  width: 65px;\n  border-radius: 50%;\n}\n\n.side_bar_logo_img_vert {\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n}\n\n.company_logo {\n  cursor: pointer;\n  width: 100%;\n  height: 50px;\n  border-bottom: 1px #6c757d solid;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 10px;\n  padding-left: 20px;\n  margin-bottom: 60px;\n}\n.company_logo:hover {\n  color: #fd7e14;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.company_logo_display_none {\n  display: none;\n}\n\n.company_logo_vert {\n  cursor: pointer;\n  height: 60px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.company_logo_img {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  margin-left: 10px;\n}\n\n.display_none {\n  display: none;\n}\n\n.quest_refresh_btn {\n  position: fixed;\n  left: 350px;\n  top: 5px;\n  z-index: 19;\n  cursor: pointer;\n  background-color: #007bff;\n}\n\n.quest_moderation_btn {\n  position: fixed;\n  top: 5px;\n  z-index: 19;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.side_bar_logo-vert {\n  width: 280px;\n  height: 70px;\n  margin: 50px 0px 120px -105px;\n  text-align: left;\n  font-size: 12px;\n  padding: 15px 10px 15px 0px;\n  cursor: pointer;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n.side_bar_logo-vert:hover {\n  color: #fd7e14;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.side_bar_logo_company_name_vert {\n  position: absolute;\n  left: 15px;\n}\n\n.modal_window {\n  position: relative;\n  -webkit-transition: all;\n  transition: all;\n}\n@media (max-width: 1440px) {\n  .modal_window {\n    position: unset;\n  }\n}\n\n.shadow {\n  width: 100%;\n  height: 100%;\n  background-color: #000;\n  opacity: 0.7;\n  position: relative;\n  top: 0px;\n  left: 0px;\n  z-index: 19;\n  position: fixed;\n}\n\n.shadow_form {\n  width: 100%;\n  height: 100%;\n  background-color: #000;\n  opacity: 0.5;\n  position: relative;\n  top: 0px;\n  left: 0px;\n  z-index: 19;\n  position: fixed;\n}\n\n.shadow_quest {\n  width: 100%;\n  height: 100%;\n  background-color: #000;\n  opacity: 0.5;\n  position: relative;\n  top: 0px;\n  left: 0px;\n  z-index: 20;\n  position: fixed;\n}\n\n.shadow_form_off {\n  display: none;\n}\n\n.modal_form {\n  background-color: #fff;\n  padding: 40px;\n  position: absolute;\n  position: fixed;\n  top: 20vh;\n  left: 30%;\n  width: 40%;\n  z-index: 20;\n  -webkit-animation: opacity_1 0.75s;\n          animation: opacity_1 0.75s;\n}\n\n.modal_form_off {\n  background-color: #fff;\n  padding: 40px;\n  position: absolute;\n  position: fixed;\n  top: 20vh;\n  left: 30%;\n  width: 40%;\n  z-index: 20;\n  -webkit-animation: opacity_0 0.75s;\n          animation: opacity_0 0.75s;\n}\n\n.modal_form_quit {\n  background-color: #fff;\n  padding: 40px;\n  position: absolute;\n  position: fixed;\n  top: 20vh;\n  left: 30%;\n  width: 40%;\n  z-index: 20;\n}\n\n.modal_form_off_quit {\n  background-color: #fff;\n  padding: 40px;\n  position: absolute;\n  position: fixed;\n  top: 20vh;\n  left: 30%;\n  width: 40%;\n  z-index: 20;\n}\n\n.form_main {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 70vw !important;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  z-index: 20;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n@media (max-width: 1440px) {\n  .form_main {\n    width: 1100px !important;\n    position: absolute;\n    left: 10vw;\n  }\n}\n.form_main .form_container {\n  position: relative;\n  max-width: 98%;\n  max-height: 60vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n@media (max-width: 1440px) {\n  .form_main .form_container {\n    width: 900px !important;\n    overflow-x: auto;\n  }\n}\n\n.form_main_1 {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 70vw !important;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  z-index: 20;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n@media (max-width: 1440px) {\n  .form_main_1 {\n    position: absolute;\n    width: 100% !important;\n    top: 0px;\n    left: 0px;\n  }\n}\n.form_main_1 .invite_by_email_content {\n  padding: 20px 40px 40px 80px;\n}\n@media (max-width: 1440px) {\n  .form_main_1 .invite_by_email_content {\n    overflow-y: auto;\n    width: 100% !important;\n  }\n}\n.form_main_1 .form_container {\n  max-width: 98% !important;\n  max-height: 60vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n@media (max-width: 1440px) {\n  .form_main_1 .form_container {\n    overflow-y: auto;\n    width: 100% !important;\n  }\n}\n\n.form_main_view {\n  position: relative;\n  width: 70vw;\n  background-color: #fff;\n  border-radius: 5px;\n  margin: 5px auto;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  z-index: 20;\n}\n.form_main_view .form_alert {\n  margin-bottom: 0;\n  cursor: pointer;\n}\n\n.btn_form {\n  margin: 10px 10px;\n  width: 320px;\n  height: 160px;\n  -webkit-transition: 500ms;\n  transition: 500ms;\n  background-color: #adb5bd;\n  color: #fff;\n  font-weight: 400;\n  border: 0;\n  position: relative;\n  font-size: 18px;\n  -webkit-box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);\n          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);\n}\n\n.btn_card_style {\n  display: inline-block;\n  cursor: pointer;\n}\n\n.btn_form_header {\n  background-color: #9fa5aa;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  gap: 10px;\n  height: 60px;\n}\n\n.btn_form_body {\n  text-align: center;\n}\n\n.btn_form_title {\n  font-size: 15px;\n  margin-top: 20px;\n}\n\n.btn_form.active .check {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n}\n\n.btn_form .check {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n}\n\n.btn_form.active {\n  background-color: #73c586 !important;\n}\n\n.btn_form_header.active {\n  background-color: #28a745 !important;\n}\n\n.btn_form_content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 100px;\n}\n\n.btn_trade_form {\n  margin: 10px;\n  width: 200px;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n.btn_trade_form:hover {\n  -webkit-box-shadow: 3px 3px 5px #6c757d;\n          box-shadow: 3px 3px 5px #6c757d;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.span_title {\n  margin: 20px 0 -15px 15px;\n}\n\n.calendar {\n  margin: 25px 0 0 0;\n  padding: 0 0 0 20px;\n}\n\n.phone_form {\n  margin-top: 24px;\n}\n\n.date_trade_text {\n  padding-top: 30px;\n}\n\n.class-mask-error {\n  background-color: #dc3545;\n}\n\n.quest_main_alert {\n  position: relative;\n  width: 99%;\n  height: 50px;\n}\n\n.quest_alert {\n  position: absolute;\n  top: 50px;\n  width: 100%;\n}\n\n.anketa_true {\n  background-color: #F4F6F9;\n  padding: 0;\n  min-height: 77.5vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -ms-flex-line-pack: start;\n      align-content: flex-start;\n  min-width: 1024px;\n  margin: 50px auto 80px auto;\n  max-width: 1400px;\n}\n.anketa_true > button {\n  width: 250px;\n  height: 150px;\n  margin: 5px;\n  text-align: center;\n}\n\n.anketa_new {\n  padding: 0;\n  min-height: 77.5vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -ms-flex-line-pack: start;\n      align-content: flex-start;\n}\n\n.footer {\n  font-size: 14px;\n  letter-spacing: 1px;\n  background-color: #fff;\n  padding-left: 15px;\n  padding-right: 15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #9fa5aa;\n  font-weight: bold;\n  height: 57px;\n  border-top: #ccc 1px solid;\n}\n@media (max-width: 1440px) {\n  .footer {\n    width: 100% !important;\n  }\n}\n\n.card_block_no_position {\n  position: unset;\n}\n\n.footer_vert {\n  left: 55px;\n  width: 2000px;\n}\n\n.footer_horizontal {\n  left: 260px;\n}\n\ninput[placeholder] {\n  text-overflow: ellipsis;\n  font-size: 16px;\n}\n\ninput::-moz-placeholder {\n  text-overflow: ellipsis;\n  font-size: 16px;\n}\n\ninput:-moz-placeholder {\n  text-overflow: ellipsis;\n  font-size: 16px;\n}\n\ninput:-ms-input-placeholder {\n  text-overflow: ellipsis;\n  font-size: 16px;\n}\n\n.form-check-input {\n  width: 20px;\n  height: 20px;\n  margin-top: 2px;\n  margin-left: -1.5rem;\n}\n\n.fifteen_a_link {\n  color: #343a40;\n  text-decoration: none !important;\n}\n.fifteen_a_link:hover {\n  color: #6c757d;\n}\n\n.render_value {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 2px 10px;\n  background-color: rgba(212, 220, 231, 0.267);\n}\n\n.main_down_span {\n  display: inline-block;\n  cursor: pointer;\n  margin-left: 10px;\n  margin-right: 10px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.main_down_span:hover {\n  background-color: rgba(187, 185, 185, 0.993);\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.production-accordion {\n  background-color: #fff;\n}\n.production-accordion__card__header {\n  cursor: pointer;\n  text-align: center;\n  padding: 0;\n  background-color: #007bff;\n  color: #fff;\n  font-weight: 400;\n  font-size: 18px;\n  margin: 1px;\n  border-radius: 3px;\n}\n\n.icon_top_navbar_company_name {\n  padding: 4px 24px;\n  margin-top: 0;\n  font-weight: bolder;\n}\n\n.icon_leave_modal {\n  color: #dc3545;\n  padding-bottom: 5px;\n}\n\n.icon_primary {\n  color: #007bff;\n  padding-bottom: 5px;\n}\n\n.icon_secondery {\n  color: #adb5bd;\n  padding-bottom: 2px;\n}\n\n.icon_success {\n  color: #73c586;\n  padding-bottom: 2px;\n  padding-right: 5px;\n}\n\n.text-center {\n  border: #ccc solid 1px;\n}\n\n.modal_common {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 4px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n  width: 900px;\n  min-width: 500px;\n}\n@media (max-width: 1440px) {\n  .modal_common {\n    width: 900px !important;\n  }\n}\n\n.modal_common_table {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 1100px !important;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n\n.pipe_table_wrap {\n  padding: 10px 20px;\n  overflow-x: auto;\n  max-height: 550px;\n}\n\n.loader_centered {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.button_group_table {\n  position: absolute;\n  right: 30px;\n  bottom: -60px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n}\n\n.equipment_table_style {\n  width: 1400px;\n  table-layout: fixed;\n  position: relative;\n  margin-bottom: 80px;\n}\n\n.modal_common_2 {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 5px #000;\n          box-shadow: 0 0 5px #000;\n  border-radius: 4px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n\n.modal_common_mini {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  width: 70%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 4px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n\n.th_table_style {\n  font-size: 16px;\n  word-wrap: break-word;\n}\n\n.modal_common_ {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n\n.modal_common_0 {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 800px !important;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n\n.modal_common_1 {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 1100px !important;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n@media (max-width: 1440px) {\n  .modal_common_1 {\n    position: absolute;\n    width: 1100px !important;\n  }\n}\n.modal_common_1 .participant_lot_container {\n  height: 68vh !important;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 1000px !important;\n  margin: 0 auto;\n}\n.modal_common_1 .participant_lot_container .form_container {\n  position: relative;\n  max-width: 98%;\n  max-height: 60vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n@media (max-width: 1440px) {\n  .modal_common_1 .participant_lot_container {\n    width: 950px !important;\n  }\n}\n@media (max-width: 1440px) {\n  .modal_common_1 .participant_lot_container_padding {\n    padding: 0 30px;\n  }\n}\n\n.min_height_570 {\n  min-height: 570px;\n}\n\n.modal_small_access {\n  font-size: 14px;\n  margin-left: 15px;\n  overflow-y: auto;\n  height: 30vh;\n  min-height: 300px;\n}\n\n.modal_slide_out_warning {\n  position: fixed;\n  left: 0px;\n  top: 40vh;\n  padding: 15px 20px;\n  border-radius: 5px;\n  -webkit-animation: company_is_added ease-in-out 3s;\n          animation: company_is_added ease-in-out 3s;\n}\n\n.modal_main_loading {\n  background-color: #e9ecef;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 200px;\n  height: 100px;\n  z-index: 30;\n  border-radius: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n  -webkit-box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);\n          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);\n}\n\n.modal_main_saving {\n  position: absolute;\n  position: fixed;\n  top: 40%;\n  left: 0vw;\n  width: 15vw;\n  height: 80px;\n  margin-left: -30vw;\n  padding-top: 10px;\n  font-size: 18px;\n  text-align: center;\n  background-color: #e9ecef;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  z-index: 21;\n  -webkit-animation: save ease-in-out 2s;\n          animation: save ease-in-out 2s;\n  -webkit-box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);\n          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);\n}\n\n.modal_information {\n  position: absolute;\n  position: fixed;\n  top: 40%;\n  left: 45%;\n  width: 20vw;\n  height: 150px;\n  padding-top: 10px;\n  font-size: 18px;\n  text-align: center;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  z-index: 21;\n  -webkit-box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);\n          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);\n}\n@media (max-width: 1440px) {\n  .modal_information {\n    width: 300px;\n  }\n}\n\n.animation_for_modal {\n  -webkit-animation: information ease-in-out 3s;\n          animation: information ease-in-out 3s;\n}\n\n.container_common {\n  padding: 10px;\n  margin-top: 40px;\n  margin-bottom: 30px;\n}\n\n.container_chat {\n  padding: 10px;\n  margin-top: 10px;\n}\n\n.container_height_overflow {\n  height: 100vh;\n  overflow: hidden;\n  width: 90%;\n  margin: 60px auto 80px auto;\n}\n@media (max-width: 1440px) {\n  .container_height_overflow {\n    width: 97% !important;\n  }\n}\n.container_height_overflow .employees_modal_small {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 4px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n  width: 600px;\n  min-width: 500px;\n}\n@media (max-width: 1440px) {\n  .container_height_overflow .employees_modal_small {\n    position: absolute;\n    width: 600px;\n    -webkit-transform: none;\n            transform: none;\n    top: 25%;\n    left: 35%;\n  }\n}\n.container_height_overflow .employees_modal_big {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 4px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n  width: 900px;\n  min-width: 500px;\n}\n@media (max-width: 1440px) {\n  .container_height_overflow .employees_modal_big {\n    position: absolute;\n    width: 900px;\n    -webkit-transform: none;\n            transform: none;\n    top: 10%;\n    left: 10%;\n  }\n}\n@media (max-width: 1440px) {\n  .container_height_overflow .employees_table_list {\n    width: 100% !important;\n  }\n}\n\n.container_mt_2_mb_0 {\n  margin-top: 2.5rem;\n  margin-bottom: 0;\n}\n\n.container_search_body {\n  padding: 20px 0;\n}\n\n.container_search {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.container_laboratory {\n  margin-bottom: 0;\n  min-height: 78vh;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.container_jumbotron {\n  margin-bottom: 0;\n  position: relative;\n}\n\n.quest_btn_container {\n  background-color: #F4F6F9;\n}\n\n.container_questionairy_btn {\n  text-align: center;\n  width: 1140px !important;\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n@media (max-width: 1440px) {\n  .container_questionairy_btn {\n    width: 100% !important;\n  }\n}\n\n.container_participant_trade {\n  position: absolute;\n  left: 0;\n  top: -10%;\n}\n\n.display_flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.flex_justify_center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.container_check_inn {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 0;\n}\n\n.container_flex_start {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.container_flex_end {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n\n.container_flex_direction_col {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.flex_align_items_end {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n\n.flex_align_items_center {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.flex_align_items_start {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.container_flex_row_wrap {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.container_flex_start_wrap {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.container_flex_wrap_bordered {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  border: 1px solid #eee;\n  padding-left: 5px;\n}\n\n.container_flex_wrap {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.header_alert_common {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 55px;\n  border-radius: 5px 5px 0 0;\n  font-weight: bold;\n}\n\n.trade_card_header {\n  border-bottom: 0;\n  background-color: #f0f1f2;\n  height: 50px;\n}\n\n.trade_card_header_error {\n  border-bottom: 0;\n  background-color: #e87c86;\n  height: 50px;\n  color: #fff;\n}\n\n.trade_card_header_warning {\n  border-bottom: 0;\n  background-color: #ffc107;\n  height: 50px;\n  color: #fff;\n}\n\n.btn_delete {\n  background-color: transparent;\n  border: none;\n}\n\n.btn_outlined {\n  background-color: transparent;\n  border: 1px #6c757d solid;\n  color: #6c757d;\n}\n\n.btn_info_filled {\n  background-color: #17a2b8;\n  border: 0;\n}\n\n.btn_info_filled_ml_20 {\n  margin-left: 20px;\n  background-color: #17a2b8;\n  border: 0;\n}\n\n.btn_chat {\n  background-color: transparent;\n  border: 0;\n  padding-left: 0;\n}\n\n.btn_chat:disabled {\n  background-color: transparent;\n}\n\n.btn_chat:hover,\n.btn_chat:focus,\n.btn_chat:active {\n  background-color: transparent !important;\n  border: 0 !important;\n  outline: none !important;\n  outline-offset: none !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n\n.btn_modal_group {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 100%;\n  gap: 8px;\n}\n\n.startChatBtn,\n.startChatBtn:hover {\n  position: fixed;\n  bottom: 90px;\n  right: 10px;\n}\n\n.startChatBtn,\n.chatStopBtn {\n  opacity: 70%;\n}\n\n.startChatBtn:hover,\n.chatStopBtn:hover {\n  opacity: 100%;\n}\n\n.modal_footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.phone_mask {\n  margin-bottom: 8px;\n  margin-top: 8px;\n}\n\n.select_form_label {\n  font-size: 12px;\n  color: #999;\n  margin-bottom: 0.125rem;\n  margin-top: 0.375rem;\n}\n\n.phone_mask_label {\n  margin-bottom: -21px;\n  padding-top: 5px;\n  font-size: 12px;\n  color: #999;\n}\n\n.calendar_col_style {\n  font-size: 12px;\n  color: #999;\n  margin: 0 0 -17px 10px;\n}\n\n.addedToTable {\n  color: #fff;\n  font-weight: bolder;\n  background-color: #73c586;\n}\n\n.white_bgc {\n  background-color: #fff;\n  color: #343a40;\n}\n\n.file_style {\n  max-width: 300px;\n  margin: 20px 10px;\n  border: 1px solid none;\n  padding: 10px;\n  min-height: 100px;\n  border-radius: 3px;\n  background-color: #6c757d;\n  color: #fff;\n}\n\n.file_body_style {\n  width: 18rem;\n  background-color: #9fa5aa;\n  color: #f7f7f7;\n}\n\n.file_body_style_w_50 {\n  width: 50rem;\n  background-color: #9fa5aa;\n  color: #f7f7f7;\n}\n\n.border_bottom_underline {\n  border-bottom: 1px solid #ccc;\n}\n\n.border_bottom_underline_100 {\n  width: 100%;\n  border-bottom: 1px solid #ccc;\n}\n\n.border_top_topline_100 {\n  width: 100%;\n  border-top: 1px solid #ccc;\n}\n\n.border_top_topline {\n  border-top: 1px solid #ccc;\n}\n\n.form_four_row {\n  width: 200px;\n  height: 30px;\n  cursor: pointer;\n  padding: 2px 0;\n  color: #fd7e14;\n}\n\n.gost_metal_input_style {\n  padding-top: 25px;\n  width: 25%;\n}\n\n.text-muted {\n  font-size: 10px;\n  padding-left: 5px;\n}\n\n.display_block {\n  display: block;\n}\n\n.display_inline_block {\n  display: inline-block;\n}\n\n.display_inline {\n  display: inline;\n}\n\n.float {\n  float: right;\n}\n\n.color_fff {\n  color: #fff;\n}\n\n.color_000 {\n  color: #000;\n}\n\n.color_info {\n  color: #17a2b8;\n}\n\n.text_align_center {\n  text-align: center;\n}\n\n.background_info {\n  background-color: #17a2b8;\n}\n\n.background_danger {\n  background-color: #e87c86;\n}\n\n.width_30px {\n  width: 30px;\n}\n\n.width_50px {\n  width: 50px;\n}\n\n.error_okved {\n  background-color: #dc3545 !important;\n}\n\n.width_100px {\n  width: 100px;\n}\n\n.width_200px {\n  width: 200px;\n}\n\n.width_100pr {\n  width: 100%;\n}\n\n.width_95pr {\n  width: 95%;\n}\n\n.width_290 {\n  width: 290px;\n}\n\n.max_width_220 {\n  max-width: 220px;\n}\n\n.width_220 {\n  width: 220px;\n}\n\n.width_500 {\n  width: 500px;\n}\n\n.width_40 {\n  width: 40% !important;\n}\n\n.width_50 {\n  width: 50% !important;\n}\n\n.width_590 {\n  width: 590px !important;\n}\n@media (max-width: 1440px) {\n  .width_590 {\n    width: 590px !important;\n  }\n}\n\n.width_60 {\n  width: 60%;\n}\n\n.width_90 {\n  width: 90%;\n}\n\n.width_50 {\n  width: 50px;\n}\n\n.width_160 {\n  width: 160px;\n}\n\n.width_150 {\n  width: 150px;\n}\n\n.height_60 {\n  height: 60px;\n}\n\n.height_450 {\n  height: 450px;\n}\n\n.height_370 {\n  height: 370px;\n}\n\n.height_500 {\n  height: 500px;\n}\n\n.height_600 {\n  height: 600px;\n}\n\n.height_80vh {\n  height: 80vh;\n}\n\n.height_160 {\n  height: 160px;\n}\n\n.height_100 {\n  height: 100px;\n}\n\n.height_300 {\n  height: 300px;\n}\n\n.height_350 {\n  height: 350px;\n}\n\n.height_600 {\n  height: 600px;\n}\n\n.overflow_y_scroll {\n  overflow-y: scroll;\n}\n\n.overflow_x_hidden {\n  overflow-x: hidden;\n}\n\n.overlay_y_scroll_on {\n  overflow-y: scroll;\n}\n\n.overflow_y_auto {\n  overflow-y: auto;\n}\n\n.overflow_y_hidden {\n  overflow-y: hidden;\n}\n\n.p_0 {\n  padding: 0;\n}\n\n.p_1 {\n  padding: 1px;\n}\n\n.p_3 {\n  padding: 3px;\n}\n\n.p_40 {\n  padding: 40px;\n}\n\n.pr_10 {\n  padding-right: 10px;\n}\n\n.pb_2 {\n  padding-bottom: 2px;\n}\n\n.pb_3 {\n  padding-bottom: 3px;\n}\n\n.pb_4 {\n  padding-bottom: 4px;\n}\n\n.pb_5 {\n  padding-bottom: 5px;\n}\n\n.pb_20 {\n  padding-bottom: 20px;\n}\n\n.pb_0 {\n  padding-bottom: 0 !important;\n}\n\n.pt_10 {\n  padding-top: 10px;\n}\n\n.pt_25 {\n  padding-top: 25px;\n}\n\n.pl_0 {\n  padding-left: 0;\n}\n\n.ml_10 {\n  margin-left: 10px;\n}\n\n.ml_6em {\n  margin-left: 6em;\n}\n\n.m_0 {\n  margin: 0;\n}\n\n.m_0_5 {\n  margin: 0 5px;\n}\n\n.mt_10 {\n  margin-top: 10px;\n}\n\n.mt_20 {\n  margin-top: 20px;\n}\n\n.mb_20 {\n  margin-bottom: 20px;\n}\n\n.mb_10 {\n  margin-bottom: 10px;\n}\n\n.mb_0 {\n  margin-bottom: 0px;\n}\n\n.mt_0 {\n  margin-top: 0px;\n}\n\n.m_0_10 {\n  margin: 0 10px;\n}\n\n.m_10_0_15_10 {\n  margin: 10px 0 15px 10px;\n}\n\n.fw_bolder {\n  font-weight: bolder;\n}\n\n.fw_bold_color_dark_grey {\n  font-weight: 600;\n  color: #343a40;\n}\n\n.f_size_09em {\n  font-size: 0.9em;\n}\n\n.f_size_095em {\n  font-size: 0.95em;\n}\n\n.f_size_1em {\n  font-size: 1.1em;\n}\n\n.z_index_1000 {\n  z-index: 1000;\n}\n\n.z_index_1001 {\n  z-index: 1001;\n}\n\n.z_index_19 {\n  z-index: 19;\n}\n\n.z_index_20 {\n  z-index: 20;\n}\n\n.z_index_21 {\n  z-index: 21;\n}\n\n.z_index_extra_big {\n  z-index: 1001111;\n}\n\n.flex_gap_20 {\n  gap: 20em;\n}\n\n.flex_space_around {\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n\n.flex_gap_8 {\n  gap: 8px;\n}\n\n.flex_align_center {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.text_decoration_none {\n  text-decoration: none;\n}\n\n.transition_05s {\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.transition_075s {\n  -webkit-transition: 0.75s;\n  transition: 0.75s;\n}\n\n.cursor_pointer {\n  cursor: pointer;\n}\n\n.cursor_auto {\n  cursor: auto;\n}\n\n.table_td_hover_style {\n  cursor: auto;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n.table_td_hover_style:hover {\n  color: #fff;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  cursor: pointer;\n  background-color: #ccc;\n}\n.table_td_hover_style:active {\n  background-color: #9fa5aa;\n  -webkit-transition: 0.12s;\n  transition: 0.12s;\n}\n\n.table_no_hover_style {\n  cursor: auto;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.no_hover {\n  width: 100px;\n  cursor: auto;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.cursor_no_pointer {\n  cursor: default;\n}\n\n.h6_forgings_group {\n  padding-top: 27px;\n  margin-right: 5px;\n}\n\n.h5_questionaire {\n  cursor: pointer;\n  margin-top: 20px;\n  margin-left: 20px;\n}\n\n.arrow_right,\n.arrow_left {\n  min-width: auto;\n  max-width: 300px;\n  margin-left: auto;\n  margin-bottom: 5px;\n  margin-top: 10px;\n  padding: 5px 10px;\n  position: relative;\n  border-radius: 15px;\n  color: #f8f9fa;\n  overflow-wrap: break-word;\n  height: auto;\n}\n\n.arrow_right {\n  background: #5ad18b;\n}\n\n.arrow_left {\n  background: rgb(161, 161, 161);\n  margin-left: 20px;\n}\n\n.arrow_right:before,\n.arrow_left:before {\n  content: \"\";\n  border: solid transparent;\n  position: absolute;\n  bottom: 10px;\n  border-width: 5px;\n  margin-bottom: 1px;\n}\n\n.arrow_right:before {\n  left: 100%;\n  border-left-color: #5ad18b;\n}\n\n.arrow_left:before {\n  right: 100%;\n  border-right-color: #9fa5aa;\n}\n\n.chat_message_date_style {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  color: #343a40;\n  font-size: 0.7em;\n}\n\n.input.form-control {\n  border: #ccc 1px solid;\n}\n\ninput.form-control:focus,\n.input.form-control:active {\n  border: #ccc 1px solid;\n  outline: none !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n\n.recipientStyle,\n.recipientStyleActive {\n  padding: 10px;\n  cursor: pointer;\n  background-color: #3e4850;\n  color: #fff;\n  font-weight: bolder;\n  padding-left: 15px;\n  border-radius: 5px;\n  font-size: 14px;\n}\n\n.recipientStyleActive {\n  background-color: #3e4850;\n}\n\n.recipientStyleActive {\n  background-color: #364048;\n}\n\n.avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.modal_chat {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n  overflow: hidden;\n}\n@media (max-width: 1440px) {\n  .modal_chat {\n    position: absolute;\n    top: 30px;\n    left: 300px;\n    right: 0;\n  }\n}\n.modal_chat .chat_grid_layout {\n  background-color: #303a42;\n  /* outline: 2px solid #303a42; */\n  display: grid;\n  grid-template-areas: \"aside sidebar chatHeader\" \"aside sidebar messagesContent\" \"aside sidebar messageEnterArea\";\n  grid-template-columns: 70px 225px 1fr;\n  padding: 0 !important;\n  height: 600px;\n}\n.modal_chat .chat_grid_layout .leftChatBar {\n  grid-area: aside;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: baseline;\n      -ms-flex-pack: baseline;\n          justify-content: baseline;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  padding: 0;\n  margin: 0;\n  height: 600px;\n  border-radius: 10px;\n}\n.modal_chat .chat_grid_layout .leftChatBar .leftBarIcons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 10px;\n  width: 100%;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 5px;\n}\n.modal_chat .chat_grid_layout .leftChatBar .chat_online_circle {\n  width: 15px;\n  height: 15px;\n  position: absolute;\n  bottom: -3px;\n  right: 1px;\n  background-color: #73c586;\n  border-radius: 50%;\n  border: 2px solid #343a40;\n}\n.modal_chat .chat_grid_layout .chatNav {\n  grid-area: sidebar;\n  border: 0;\n  height: 600px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-color: #364048;\n  overflow-y: auto;\n}\n.modal_chat .chat_grid_layout .chatNav .searchBarStyle,\n.modal_chat .chat_grid_layout .chatNav .searchBarStyle:focus,\n.modal_chat .chat_grid_layout .chatNav .searchBarStyle:active {\n  width: 80%;\n  border-radius: 15px;\n  font-size: 14px !important;\n  margin-top: 20px;\n  margin-bottom: 40px;\n  background-color: #303a42;\n  border: 0 !important;\n  color: #fff;\n}\n.modal_chat .chat_grid_layout .containerChat {\n  padding: 0px;\n  margin: 0px;\n}\n.modal_chat .chat_grid_layout .containerChat .contentArea {\n  grid-area: messagesContent;\n  height: 490px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-color: #f8f9fb;\n  padding-right: 20px;\n}\n.modal_chat .chat_grid_layout .containerChat .chat_toast {\n  width: 350px;\n  background-color: #fff;\n  position: absolute;\n  bottom: 50px;\n  margin: 0 0 0 3px;\n}\n.modal_chat .chat_grid_layout .containerChat .enterMessageArea {\n  grid-area: messageEnterArea;\n  background-color: #fff;\n  height: 50px;\n}\n.modal_chat .chat_grid_layout .containerChat .enterMessageArea .enterMessageInputSpan {\n  width: 90%;\n  padding-right: 5px;\n  background-color: #fff;\n}\n\n.chatHeader {\n  grid-area: chatHeader;\n  /* border: 1px #ccc solid; */\n  margin: 0;\n  background-color: #f8f9fb;\n  border-radius: 0;\n  height: 60px;\n}\n\n.leftBarIcon {\n  background-color: transparent !important;\n  border: 0 !important;\n  /* border-radius: 50%; */\n  padding: 10px 22px !important;\n  width: 100%;\n  -webkit-transition: none !important;\n  transition: none !important;\n}\n\n.leftBarIcon:hover,\n.leftBarIcon:focus,\n.leftBarIcon:active {\n  background-color: #3e4850 !important;\n  /* background-color: transparent !important; */\n  border: 0 !important;\n  outline: none !important;\n  outline-offset: none !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  border-left: 3px #5ad18b solid !important;\n  -webkit-transition: none !important;\n  transition: none !important;\n}\n\n.width_400_height_200 {\n  width: 400px;\n  height: 200px;\n}\n\n.dropdown-toggle::after {\n  display: none !important;\n  content: none !important;\n  border-top: none !important;\n  content: 0 !important;\n  background-color: transparent !important;\n  color: transparent !important;\n}\n\n.filter_col_label {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n\n.filter_col_input {\n  -webkit-box-flex: 2;\n      -ms-flex-positive: 2;\n          flex-grow: 2;\n}\n\n.filter_box_h5 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.filter_box_container {\n  padding-top: 40px;\n  overflow-x: auto;\n  width: 90%;\n  margin: 50px auto 80px auto;\n  padding-left: 50px;\n  padding-right: 50px;\n}\n@media (max-width: 1440px) {\n  .filter_box_container {\n    width: 1024px !important;\n  }\n}\n\n.filter_box_container_modal {\n  overflow-x: auto;\n  width: 90%;\n  margin: 50px auto 80px auto;\n}\n@media (max-width: 1440px) {\n  .filter_box_container_modal {\n    width: 1024px !important;\n  }\n}\n\n.filter_box {\n  margin-bottom: 40px;\n  border: 1px #f8f9fa solid;\n  padding: 20px;\n  border-radius: 5px;\n  background-color: #fff;\n}\n@media (max-width: 1440px) {\n  .filter_box {\n    width: 100%;\n  }\n}\n\n.filter_alert {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.invitation_alert {\n  height: 69px;\n}\n\n.right_navbar_capacity {\n  position: relative;\n}\n\n.right_navbar_capacity_modal {\n  position: absolute;\n  right: 20px;\n  top: 17px;\n  padding: 2px;\n  z-index: 200;\n  width: 420px;\n}\n\n.left_navbar_capacity_modal {\n  position: absolute;\n  right: 450px;\n  top: 17px;\n  padding: 2px;\n  z-index: 200;\n}\n\n.universal_table {\n  position: relative;\n}\n@media (max-width: 1440px) {\n  .universal_table {\n    width: 100%;\n  }\n}\n\n.status_modal {\n  position: absolute;\n  right: 15px;\n  bottom: -185px;\n  width: 190px;\n  text-align: center;\n}\n\n.upper_label_position {\n  color: #777;\n  font-size: 12px;\n  position: absolute;\n  left: 25px;\n  top: -18px;\n}\n\n.upper_label_position_2 {\n  color: #777;\n  font-size: 12px;\n  position: absolute;\n  left: 50px;\n  top: 10px;\n}\n\n.upper_label_check_inn {\n  color: #777;\n  font-size: 11px;\n  position: absolute;\n  left: 10px;\n  top: -18px;\n}\n\n.navbar-toggler-icon,\n.collapsed {\n  display: none;\n}\n\n.upoad_file {\n  padding: 5px 10px;\n  cursor: pointer;\n  background-color: #E5E5E5;\n  border: 1px #ccc solid;\n  border-radius: 3px;\n  font-weight: bolder;\n}\n\n.next_btn_file {\n  position: fixed;\n  right: 400px;\n  bottom: 250px;\n}\n\n.list_item_stile {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 10%;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  cursor: pointer;\n  padding: 5px 20px;\n}\n\n.company_name_in_alert {\n  position: absolute;\n  font-size: small;\n  top: 0px;\n  right: 20px;\n}\n\n.navbar_info_span {\n  font-size: 12px;\n  position: absolute;\n  top: -9px;\n  right: -3px;\n  color: #fff;\n  width: 15px;\n  height: 15px;\n  text-align: center;\n  border-radius: 3px;\n  height: 17px;\n  background-color: #28a745;\n  top: -7px;\n  right: 5px;\n}\n\n.navbar_info_span_date {\n  width: 65px;\n}\n\n.navbar_info_span_weight {\n  width: 40px;\n}\n\n.navbar_info_span_msg {\n  background-color: #dc3545;\n}\n\n.navbar_info_span_rating {\n  background-color: #007bff;\n}\n\n.lot_succesfully_saved_msg {\n  background-color: #fff;\n  height: 174px;\n  color: #73c586;\n}\n\n.chat_reply_arrow_common {\n  position: absolute;\n  color: #F8F9FB;\n  bottom: calc(50% - 15px);\n  cursor: pointer;\n  border: 0;\n  border-radius: 50%;\n  padding: 2px 4px;\n  -webkit-transition: 0.9s;\n  transition: 0.9s;\n}\n\n.chat_reply_arrow_right_ {\n  left: -30px;\n}\n\n.chat_reply_arrow_right {\n  left: -45px;\n}\n\n.chat_reply_arrow_left {\n  left: 310px;\n}\n\n.chat_reply_arrow_left_ {\n  left: 304px;\n}\n\n.message_on_hover:hover .chat_reply_arrow_left, .message_on_hover:hover .chat_reply_arrow_left_, .message_on_hover:hover .chat_reply_arrow_right_, .message_on_hover:hover .chat_reply_arrow_right {\n  color: #fff;\n  border-radius: 50%;\n  padding: 2px 4px;\n  background-color: #59a9ff;\n  -webkit-transition: 0.9s;\n  transition: 0.9s;\n}\n\n.chat_question_flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n}\n\n.very_common_modal {\n  position: absolute;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 4px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n\n.very_common_modal_big {\n  position: fixed;\n  top: 100px;\n  left: 20vw;\n  width: 70%;\n  height: 80%;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n\n.absolute_pos_for_modal_footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.navibar_drop_menu_main {\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 19;\n  -webkit-animation: drop_menu ease-in-out 0.5s;\n          animation: drop_menu ease-in-out 0.5s;\n}\n\n.navibar_drop_menu {\n  width: \"300px\";\n  height: auto;\n  background-color: #ccc;\n  border-radius: 3px;\n  padding: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  position: absolute;\n  z-index: 19;\n  top: 55px;\n  right: 20px;\n}\n\n.update_button {\n  padding: 0 5px 3px 5px;\n  border-radius: 3px;\n  cursor: pointer;\n  margin-left: 5px;\n  color: #7b7f83;\n  font-weight: 400;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.update_button:hover {\n  background-color: #adb5bd;\n  color: #fff;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n\n.reply_msg_style {\n  border-left: solid 1px #fff;\n  color: #fff;\n  padding-left: 10px;\n  font-style: italic;\n  margin-bottom: 5px;\n}\n\n.box_shadow {\n  -webkit-box-shadow: 2px 2px 8px rgba(150, 150, 150, 0.5);\n          box-shadow: 2px 2px 8px rgba(150, 150, 150, 0.5);\n}\n\n.conditions_style {\n  font-size: 16px;\n  height: 200px;\n  overflow-y: auto;\n  padding: 10px;\n}\n\n.read_conditions_style {\n  cursor: pointer;\n  font-size: 0.8em;\n  color: #7b7f83;\n}\n\n.dotted_underline {\n  display: inline-block;\n  border-bottom: dashed 1px #7b7f83;\n}\n\n.wrapper_lot {\n  width: 100% !important;\n  margin: 50px auto !important;\n}\n@media (max-width: 1440px) {\n  .wrapper_lot {\n    width: 1000px !important;\n    margin: 50px 20px !important;\n  }\n}\n.wrapper_lot .wrapper_lot_content {\n  width: 100% !important;\n}\n@media (max-width: 1440px) {\n  .wrapper_lot .wrapper_lot_content {\n    width: 100% !important;\n  }\n}\n.wrapper_lot .wrapper_lot_content .lot_type_modal {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 4px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n  width: 500px !important;\n}\n.wrapper_lot .wrapper_lot_content .wrapper_lot_content_modal {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 1100px !important;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n.wrapper_lot .wrapper_lot_content .wrapper_lot_content_modal .wrapper_lot_content_modal_content {\n  height: 68vh !important;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 1000px !important;\n  margin: 0 auto;\n}\n@media (max-width: 1440px) {\n  .wrapper_lot .wrapper_lot_content .wrapper_lot_content_modal .wrapper_lot_content_modal_content {\n    width: 1000px !important;\n  }\n}\n@media (max-width: 1440px) {\n  .wrapper_lot .wrapper_lot_content .wrapper_lot_content_modal {\n    position: absolute;\n    width: 1100px !important;\n  }\n}\n\n.wrapper_lot_participant {\n  width: 97% !important;\n  margin: 50px auto !important;\n}\n@media (max-width: 1440px) {\n  .wrapper_lot_participant {\n    width: 1100px !important;\n    margin: 50px 20px !important;\n  }\n}\n.wrapper_lot_participant .wrapper_lot_participant_position_modal {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 1100px !important;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n@media (max-width: 1440px) {\n  .wrapper_lot_participant .wrapper_lot_participant_position_modal {\n    position: absolute;\n  }\n}\n.wrapper_lot_participant .wrapper_lot_participant_position_modal .wrapper_lot_participant_position_modal_content {\n  width: 90% !important;\n  margin: 0 auto;\n}\n\n.lot_participant_modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n.lot_participant_modal .lot_participant_modal_content {\n  height: 68vh !important;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 1000px !important;\n  margin: 0 auto;\n}\n\n.invite_by_email {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 1000px;\n  background-color: #fff;\n  z-index: 20;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n}\n.invite_by_email .invite_by_email_content {\n  padding: 20px 50px 20px 50px;\n  min-height: 550px;\n  height: 600px;\n}\n\n.sh {\n  position: fixed;\n  left: 0%;\n  top: 0%;\n  -webkit-transform: translate(0%, 0%);\n          transform: translate(0%, 0%);\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 20;\n}\n\n.lot_position_modal {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 1200px !important;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n@media (max-width: 1440px) {\n  .lot_position_modal {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 1200px !important;\n  }\n}\n.lot_position_modal .lot_position_modal_content {\n  height: 68vh !important;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 1100px !important;\n  margin: 0 auto;\n}\n.lot_position_modal .lot_chosen_position_modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 1200px !important;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n\n.quit_modal {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 4px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n  width: 500px;\n  min-width: 500px;\n}\n@media (max-width: 1440px) {\n  .quit_modal {\n    position: absolute;\n  }\n}\n\n.create_template_modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 4px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n}\n@media (max-width: 1440px) {\n  .create_template_modal {\n    position: absolute;\n    width: 680px !important;\n  }\n  .create_template_modal .create_template_heading {\n    font-size: 0.99em;\n  }\n}\n\n.dropdown-menu {\n  overflow-y: hidden !important;\n  z-index: 1000000000;\n  position: absolute;\n}\n.dropdown-menu .show {\n  overflow-y: hidden !important;\n}\n@media (max-width: 1440px) {\n  .dropdown-menu .show {\n    overflow-y: hidden !important;\n  }\n}\n\n.modal_common_1_trade {\n  position: fixed;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  top: 50%;\n  left: 50%;\n  width: 80vw;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  -webkit-animation: scale_view 0.5s;\n          animation: scale_view 0.5s;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n@media (max-width: 1440px) {\n  .modal_common_1_trade {\n    position: absolute;\n    width: 1330px !important;\n  }\n}\n.modal_common_1_trade .timer_bar {\n  margin-top: 55px;\n  background-color: #f8f9fa;\n}\n.modal_common_1_trade .timer_bar_content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 20px;\n  height: 60px;\n}\n.modal_common_1_trade .modal_trade_content {\n  max-height: 65%;\n  height: 64vh;\n  max-width: 1300px;\n  overflow-y: auto;\n  margin-top: 10px;\n}\n.modal_common_1_trade .modal_trade_content .table_container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: relative;\n  margin-bottom: 40px;\n  margin-left: -15px;\n}\n.modal_common_1_trade .modal_trade_content .table_container .main_table {\n  position: absolute;\n  width: 450px;\n  z-index: 200;\n}\n.modal_common_1_trade .modal_trade_content .table_container .secondary_table {\n  overflow-x: hidden;\n  z-index: 199;\n  -webkit-transition: 0.8;\n  transition: 0.8;\n}\n.modal_common_1_trade .modal_trade_content .scroll_area {\n  position: absolute;\n  position: sticky;\n  bottom: 0px;\n  z-index: 201;\n  left: 0;\n  right: 20px;\n  background-color: transparent;\n  padding: 10px;\n}\n\n.blur_shadow_green {\n  -webkit-box-shadow: inset #73c586 0 0 5px 5px, #73c586 0 0 2px 2px;\n          box-shadow: inset #73c586 0 0 5px 5px, #73c586 0 0 2px 2px;\n}\n\n.blur_shadow_grey {\n  -webkit-box-shadow: inset #7b7f83 0 0 5px 5px, #7b7f83 0 0 2px 2px;\n          box-shadow: inset #7b7f83 0 0 5px 5px, #7b7f83 0 0 2px 2px;\n}\n\n.offline_span {\n  display: inline-block;\n  background-color: #7b7f83;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-left: 8px;\n}\n\n.online_span {\n  display: inline-block;\n  background-color: #73c586;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-left: 8px;\n}\n\n.offline_span_eye {\n  width: 8px;\n  height: 8px;\n  font-size: 10px;\n  margin-left: 8px;\n}\n\n.online_span_eye {\n  color: #28a745;\n  width: 8px;\n  height: 8px;\n  margin-left: 8px;\n}\n\n.all_modals_footer_space_between .modal-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify !important;\n      -ms-flex-pack: justify !important;\n          justify-content: space-between !important;\n}\n\n.style_for_icons {\n  margin-right: 5px;\n  padding-bottom: 2px;\n}\n\n.new_window_icon {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  padding-bottom: 6px;\n}\n\n.dropdown_codes {\n  background-color: white;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  border: 1px solid gray;\n  position: absolute;\n  right: 4em;\n  top: 88px;\n  width: 300px;\n  z-index: 32;\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow-y: auto;\n  max-height: 200px;\n}\n\n.dropdown_codes:empty {\n  border: none;\n}\n\n.dropdown_codes-row {\n  cursor: pointer;\n  text-align: start;\n  margin: 2px 0;\n  padding: 2px;\n}\n.dropdown_codes-row:hover {\n  background-color: #d5d8da;\n}\n\n.feedback {\n  position: fixed;\n  right: 20px;\n  bottom: 50px;\n  -webkit-transition: 0.9s;\n  transition: 0.9s;\n}\n.feedback .feedback_btn {\n  border-radius: 15px;\n  width: 350px;\n  height: 60px;\n  background: #17a2b8;\n  border: 1px solid #17a2b8;\n}\n.feedback .feedback_btn .feedback_icon {\n  position: absolute;\n  right: 10px;\n  -webkit-box-shadow: 2px 2px 8px rgba(150, 150, 150, 0.5);\n          box-shadow: 2px 2px 8px rgba(150, 150, 150, 0.5);\n}\n.feedback .feedback_form {\n  width: 320px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 35px;\n  height: 450px;\n  padding: 30px 10px;\n  margin-left: 16px;\n  background-color: #fafbfb;\n  -webkit-transition: 0.9s;\n  transition: 0.9s;\n  border-radius: 0 0 10px 10px;\n  -webkit-box-shadow: -2px -2px 8px rgba(150, 150, 150, 0.5);\n          box-shadow: -2px -2px 8px rgba(150, 150, 150, 0.5);\n}\n.feedback .feedback_form :nth-child(4) {\n  margin-bottom: 10px;\n}\n.feedback .feedback_form .feedback_input {\n  border-radius: 15px;\n  background-color: #F4F6F9;\n}\n.feedback .feedback_form .input_error {\n  border: 1px #e87c86 solid;\n  background-color: #e87c86;\n}\n.feedback .feedback_form .feedback_submit_btn {\n  border-radius: 15px;\n}\n\n.feedback_down {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n  font-size: 35px;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  color: #17a2b8;\n}\n\n.feedback_is_open {\n  border-radius: 50%;\n  background: #68C2D0;\n  -webkit-box-shadow: 2px 2px 8px rgba(80, 78, 78, 0.5);\n          box-shadow: 2px 2px 8px rgba(80, 78, 78, 0.5);\n  color: #fff;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.feedback_down:hover {\n  border-radius: 50%;\n  background: #68C2D0;\n  -webkit-box-shadow: 2px 2px 8px rgba(80, 78, 78, 0.5);\n          box-shadow: 2px 2px 8px rgba(80, 78, 78, 0.5);\n  color: #fff;\n}\n\n.feedback_down_lower {\n  bottom: 30px;\n}\n\n.feedback_down_higher {\n  bottom: 70px;\n}\n\n.highlighted {\n  border: 1px #28a745 solid;\n  background-color: #f1f9f3;\n}\n\n.unique_number_input {\n  border: #007bff 2px solid;\n}\n\n.base_modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background-color: #fff;\n  -webkit-box-shadow: 0 0 10px #000;\n          box-shadow: 0 0 10px #000;\n  border-radius: 5px;\n  z-index: 1000;\n}\n\n.modal_large {\n  width: 1100px;\n  height: 80vh;\n}\n\n.modal_medium {\n  width: 800px;\n  height: 60vh;\n}\n\n.modal_small {\n  width: 500px;\n  height: 40vh;\n}\n\n.modal_content {\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin: 20px;\n}\n\n.modal_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n.modal_overlay_second {\n  z-index: 1000;\n}\n\n.button_container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
